<template>
  <div id="deviceList">
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="12" md="12" lg="12" xl="10">
        <CRow>
          <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
            <label>Thao tác</label>
            <div class="dropdown btn-group" style="height: 36px;">
              <button class="btn">
                <div class="group-checkbox">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" v-model="actionData.model.selectedAll"
                      @change="changeSelectAll()" id="selectedAll" />
                    <label class="custom-control-label" for="selectedAll"></label>
                  </div>
                </div>
              </button>
              <button type="button" class="dropdown-toggle dropdown-toggle-split btn" data-toggle="dropdown"
                aria-expanded="false" aria-haspopup="true"></button>
              <div class="dropdown-menu">
                <button :disabled="actionData.model.listDeviceSelectedId.length === 0" class="dropdown-item"
                  @click="clickStopContent(null, true)" color="danger">
                  <i class="fa fa-stop-circle mr-2" style="font-size: 1.1rem!important;"></i>
                  Dừng phát thanh
                </button>
                <button :disabled="actionData.model.listDeviceSelectedId.length === 0" class="dropdown-item"
                  @click="isShowModalOnOffWattage = true" color="danger">
                  <i class="fa fa-bolt mr-2" style="font-size: 1rem!important;"></i>
                  Bật/Tắt công suất
                </button>
                <button :disabled="actionData.model.listDeviceSelectedId.length === 0" class="dropdown-item"
                  @click="isShowModalChangeVolumeMultipleDevice = true" color="danger">
                  <i class="fa fa-volume-up mr-2" style="font-size: 1rem!important;"></i>
                  Thay đổi âm lượng
                </button>
                <button v-if="$hasAuthor('ROLE_ADMIN')" :disabled="actionData.model.listDeviceSelectedId.length === 0"
                  class="dropdown-item"
                  @click="setupSelectOneAction('action_list', null, null, null, typeActionList.GET_STATUS)"
                  color="danger">
                  <i class="fa fa-retweet mr-2" style="font-size: 1rem!important;"></i>
                  Đồng bộ dữ liệu
                </button>
                <button v-if="$hasAuthor('ROLE_ADMIN')" :disabled="actionData.model.listDeviceSelectedId.length === 0"
                  class="dropdown-item"
                  @click="setupSelectOneAction('action_list', null, null, null, typeActionList.CHECK_TEMPERATURE)"
                  color="danger">
                  <i class="fa fa-thermometer-empty mr-2" style="font-size: 1rem!important;"></i>
                  Kiểm tra nhiệt độ
                </button>
                <button :disabled="actionData.model.listDeviceSelectedId.length === 0" class="dropdown-item"
                  @click="setupSelectOneAction('action_list', null, null, null, typeActionList.RESTART_LIST)"
                  color="danger">
                  <i class="fa fa-power-off mr-2" style="font-size: 1rem!important;"></i>
                  Khởi động lại thiết bị
                </button>
                <button v-if="$hasAuthor('ROLE_ADMIN')" :disabled="actionData.model.listDeviceSelectedId.length === 0"
                  class="dropdown-item"
                  @click="setupSelectOneAction('action_list', null, null, null, typeActionList.DELETE_LIST)"
                  color="danger">
                  <CIcon name="cil-trash" class="mr-2" />
                  Xóa thiết bị được chọn
                </button>
                <!-- @click="setupSelectOneAction('action_list', null, null, null, typeActionList.UPDATE_APP_LIST)" -->
                <button v-if="$hasAuthor('ROLE_ADMIN')" :disabled="actionData.model.listDeviceSelectedId.length === 0"
                  class="dropdown-item" @click="setupUpdateFW(null)" color="danger">
                  <i class="fa fa-download mr-2" />
                  Cập nhật phần mềm thiết bị được chọn
                </button>
              </div>
            </div>
          </CCol>
          <CCol xs="12" sm="5" md="5" lg="5" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_MANAGEMENT_DEVICE')">
            <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="5" md="5" lg="5" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT') || $hasAuthor('ROLE_MANAGEMENT_DEVICE')">
            <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3">
            <BaseSelect :options="connectStatusSelect.options" :data="connectStatusSelect.data"
              ref="connectStatusSelect">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3">
            <BaseSelect :options="activeStatusSelect.options" :data="activeStatusSelect.data" ref="activeStatusSelect">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3">
            <BaseInput :options="descriptionInput.options" :data="descriptionInput.data" />
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2">
            <BaseInput :options="codeInput.options" :data="codeInput.data" />
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN')">
            <BaseSelect :options="locationStatusSelect.options" :data="locationStatusSelect.data"
              ref="locationStatusSelect"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN')">
            <BaseSelect :options="typeDeviceSelect.options" :data="typeDeviceSelect.data" ref="typeDeviceSelect">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN')">
            <BaseSelect :options="monitorLevelSelect.options" :data="monitorLevelSelect.data"
              ref="monitorLevelSelect">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN')">
            <BaseInput :options="monitorReasonInput.options" :data="monitorReasonInput.data" />
          </CCol>
        </CRow>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="12" xl="2">
        <CRow>
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <div>
                <CButton style="float: right;margin-left: 5px;margin-top: 2px;" color="primary"
                  v-c-tooltip.hover="'Tải lại'" class="btn-action-primary" @click="loadDataMainTable(true)">
                  <i class="fa fa-refresh"></i>&nbsp;Tải lại
                </CButton>
                <CButton v-if="$hasAuthor('ROLE_ADMIN')"
                  style="float: right;margin-left: 5px;margin-top: 2px;" color="primary" v-c-tooltip.hover="'Xem bản đồ'"
                  class="btn-action-primary" @click="openPopupMap()">
                  <i class="fa fa-map-marker"></i>&nbsp;Xem bản đồ
                </CButton> 
                <CButton v-if="$hasAuthor('ROLE_ADMIN')" style="float: right;margin-left: 5px;margin-top: 2px;" color="success" v-c-tooltip.hover="'Cập nhật thiết bị theo NCC'"
                    class="btn-action-primary" @click="setupImport()">
                    <i class="fa fa-download"></i>&nbsp;Cập nhật NCC
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          @row-click="rowClickTable($event)" ref="mainTable">
          <template #checkbox="{ item }">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="actionData.model.listDeviceSelectedId"
                  :value="item.id" :id="item.id" />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #code="{ item }">
            <td>
              <div class="device-code-cell">
                <span :key="'code' + item.id + item.code" class="device-code-line">
                  <span class="device-code-value" v-c-tooltip:hover="item.code">{{ item.code }}</span>
                  <button
                    v-if="canUseSpeakerTest(item) && !$hasAuthor('ROLE_ADMIN')"
                    type="button"
                    class="btn btn-sm btn-outline-primary device-code-test-speaker-btn"
                    v-c-tooltip.hover="'Kiểm tra âm thanh'"
                    @click.stop="startTraditionalSpeakerTest(item)"
                  >
                    <i class="fa fa-volume-up"></i>
                  </button>
                  <CDropdown
                    v-if="canUseSpeakerTest(item) && $hasAuthor('ROLE_ADMIN')"
                    color="p-1"
                    placement="bottom-end"
                    :caret="false"
                    addTogglerClasses="device-code-test-speaker-btn btn btn-sm btn-outline-primary"
                    addMenuClasses="device-code-test-speaker-menu"
                    @click.native.stop
                  >
                    <template #toggler-content>
                      <i class="fa fa-volume-up" v-c-tooltip.hover="'Kiểm tra âm thanh'"></i>
                    </template>
                    <CDropdownItem @click="startTraditionalSpeakerTest(item)">
                      <i class="fa fa-volume-up mr-2"></i> Kiểm tra loa truyền thống
                    </CDropdownItem>
                    <CDropdownItem @click="openDigitalSpeakerTestModal(item)">
                      <i class="fa fa-rss mr-2"></i> Kiểm tra loa link số hóa
                    </CDropdownItem>
                  </CDropdown>
                  <i v-if="$hasAuthor('ROLE_ADMIN')" class="fa fa-copy device-code-copy-btn"
                    v-c-tooltip.hover="'Sao chép'"
                    @click.stop="copyPhoneNumber(item.code)"></i>
                </span>
                <span :key="'type' + item.id + item.type" class="badge badge-light device-code-type">
                  {{ item.type === 0 ? 'Truyền thanh cơ sở' : 'Tích hợp tự động' }}
                </span>
                <span
                  v-if="$hasAuthor('ROLE_ADMIN') && item.monitorLevel == 1"
                  :key="'monitor' + item.id"
                  class="badge badge-warning device-code-monitor device-code-monitor--clickable"
                  @click.stop="openMonitorView(item)"
                >Cần theo dõi</span>
                <span
                  v-if="$hasAuthor('ROLE_ADMIN') && item.monitorLevel == 2"
                  :key="'monitor' + item.id"
                  class="badge badge-danger device-code-monitor device-code-monitor--clickable"
                  @click.stop="openMonitorView(item)"
                >Cảnh báo cao</span>
              </div>
            </td>
          </template>
          <template #description="{ item }">
            <td>
              <span class="description-device">{{ item.description }}</span>
            </td>
          </template>
          <template #phoneNumber="{ item, index }">
            <td>
              <template v-if="item.networkType === 0">
                <span v-if="item.ipAddress != null && item.ipAddress != ''">
                  {{ item.ipAddress }}
                  <i v-c-tooltip="'Sao chép'" class="fa fa-copy" style="font-size: 17px;font-weight: 600;"
                    @click="copyPhoneNumber(item.ipAddress)"></i>&nbsp;
                </span>
                <span v-else v-c-tooltip:hover="{ content: getInformationPhone(item), placement: 'left' }"
                  class="badge badge-light">Chưa xác định </span>
              </template>
              <template v-else>
                <span v-if="item.phoneNumber != null && item.phoneNumber != ''">
                  <span v-c-tooltip:hover="{ content: getInformationPhone(item), placement: 'left' }">{{
                      item.phoneNumber
                    }} </span>
                  <i v-c-tooltip="'Sao chép'" class="fa fa-copy" style="font-size: 17px;font-weight: 600;"
                    @click="copyPhoneNumber(item.phoneNumber)"></i>&nbsp;
                </span>
                <span v-else v-c-tooltip:hover="{ content: getInformationPhone(item), placement: 'left' }" class="badge badge-light">Chưa xác định</span>
                <template>
                  <br />
                  <div id="bars">
                    <div class="bar"
                      :style="item.phoneSignal >= 1 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                    </div>
                    <div class="bar"
                      :style="item.phoneSignal >= 2 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                    </div>
                    <div class="bar"
                      :style="item.phoneSignal >= 3 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                    </div>
                    <div class="bar"
                      :style="item.phoneSignal >= 4 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                    </div>
                  </div>
                  <span style="font-weight: 700;">{{ generatePhoneNetWork(item) }}</span>
                </template>
              </template>

            </td>
          </template>
          <template #volume="{ item }">
            <td class="volume">
              <CDropdown color="p-1" placement="bottom-end" addMenuClasses="dropdown-volume"
                addTogglerClasses="custom-toggle-volume" :caret="false">
                <template #toggler-content>
                  <i class="fa" :class="generateIconVolume(item.volume)"
                    style="cursor: pointer;font-size: 16px!important;"></i>
                  <span class="ml-2">{{ item.volume }}
                  </span>
                </template>
                <CDropdownItem>
                  <range-slider class="slider override" min="0" max="100" step="5" v-model="item.volume"
                    @change="changeVolume(item.id, item.volume, false)">
                  </range-slider>
                </CDropdownItem>
              </CDropdown>
            </td>
          </template>
          <template #updateDate="{ item }">
            <td>
              <div>{{ $helper.formatDate(item.updateDate) }}</div>
              <div v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')"
                v-c-tooltip.hover="'Thời gian Ping cuối'" class="badge badge-info">{{
                      $helper.formatDate(item.lastTimePing) }}</div>
            </td>
          </template>
          <template #lastTimePing="{ item }">
            <td>{{ $helper.formatDate(item.lastTimePing) }}</td>
          </template>
          <template #activeStatus="{ item }">
            <td>
              <template v-if="item.type == 1">
                <span class="badge badge-light" v-if="item.activeStatus == 0"
                  style="display: inline-flex;align-items: center;" :key="'activeStatus' + item.id + item.activeStatus"
                  v-c-tooltip="'Xem nội dung'" @click.prevent="viewSchedulePlaying(item, item.type)">
                  <i class="fa fa-play-circle-o speaker " style="color:green"></i>
                  &nbsp;{{ item.micAvailable == true ? 'Có tín hiệu' : 'Không tín hiệu' }}
                  <span>{{ item.micAvailable == true ? '&nbsp;/&nbsp;' + item.bitrate : '' }}</span>
                </span>
                <span class="badge badge-light" v-if="item.activeStatus == 2"
                  style="display: inline-flex;align-items: center;">
                  <i class="fa fa-stop-circle-o speaker"></i>
                  &nbsp;Không tín hiệu
                </span>
                <br />
              </template>
              <template v-else>
                <span class="badge badge-light" v-if="item.activeStatus == 0 || item.activeStatus == 1"
                  :key="'activeStatus' + item.id + item.activeStatus" v-c-tooltip="'Xem nội dung'"
                  @click.prevent="viewSchedulePlaying(item, item.type)">
                  <i class="fa fa-play-circle-o speaker "
                    :style="item.activeStatus == 0 ? 'color:green' : 'color:#e39f00'"></i>
                  <span v-for="speaker in item.numberSpeakers">
                    <template v-if="item.activeStatus == 1">
                      <i :key="'speaker' + item.id + speaker.id" class="fa ml-2 speaker"
                        :class="speaker.running ? 'fa-volume-up' : 'fa-volume-off'"
                        :style="speaker.running ? 'color:#e39f00' : ''"></i>
                    </template>
                    <template v-else="item.activeStatus == 0">
                      <i :key="'speaker' + item.id + speaker.id" class="fa ml-2 speaker"
                        :class="speaker.running ? 'fa-volume-up' : 'fa-volume-off'"
                        :style="speaker.running ? 'color:green' : ''"></i>
                    </template>
                  </span>
                </span>
                <span class="badge badge-light" v-if="item.activeStatus == 2" v-c-tooltip.hover="'Không phát sóng'">
                  <i class="fa fa-stop-circle-o speaker"></i>
                  <span v-for="speaker in item.numberSpeakers">
                    <i class="fa fa-volume-off ml-2 speaker" :key="'speaker' + item.id + speaker.id"></i>
                  </span>
                </span>
              </template>
              <div :key="item.id + '_' + item.ramUsage">
                <CProgress v-if="item.ramUsage && item.ramUsage > 0" class="progress-xs mt-2" :color="'danger'"
                  :value="item.ramUsage" v-c-tooltip.hover="`RAM Usage: ${item.ramUsage}%`" />
                <CProgress v-if="item.cpuUsage && item.cpuUsage > 0" class="progress-xs mt-2" :color="'info'"
                  :value="item.cpuUsage" v-c-tooltip.hover="`CPU Usage: ${item.cpuUsage}%`" />
              </div>
              <div v-if="$hasAuthor('ROLE_ADMIN') && item.diskInfo">
                <CProgress class="progress-xs mt-2" :color="item.diskInfo.diskUsage > 50 ? 'warning' : 'info'" :value="item.diskInfo.diskUsage" 
                v-c-tooltip.hover="`Free Bytes: ${$helper.formatFileSize(item.diskInfo.diskFB)}<br/>
                  Total Bytes: ${$helper.formatFileSize(item.diskInfo.diskTB)}<br/>
                  Usage Percent: ${item.diskInfo.diskUsage.toFixed(0)}%`"/>
              </div>
            </td>
          </template>
          <template #connectStatus="{ item }">
            <td>
              <div style="display: inline-flex;width: 100%;height: 100%; align-items: center;">
                <i v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')"
                  v-c-tooltip.hover="'Nhiệt độ: ' + `${parseInt(item.temperature)}℃`" :key="item.temperature"
                  style="font-size: 22px;font-weight: 500;"
                  :style="item.temperature < 80 ? 'color:black;' : 'color:red;'" class="mr-2 fa"
                  :class="item.temperature < 80 ? 'fa-thermometer-quarter' : 'fa-thermometer-full'"></i>
                <div class="wattage-group" v-if="item.type == 0">
                  <template v-if="item.wattage === 1">
                    <i class="mr-2 fa fa-bolt" style="font-size: 23px;font-weight: 500;color:#2eb85c"
                      :key="'wattage' + item.id + item.wattage" v-c-tooltip.hover="'Công suất: Bật'"></i>
                  </template>
                  <template v-else-if="item.wattage === 0">
                    <i class="mr-2 fa fa-bolt" style="font-size: 23px;font-weight: 500;"
                      :key="'wattage' + item.id + item.wattage" v-c-tooltip.hover="'Công suất: Tắt'"></i>
                  </template>
                  <template v-else>
                    <i class="mr-2 fa fa-ban" style="font-size: 23px;font-weight: 500;"
                      :key="'wattage' + item.id + item.wattage" v-c-tooltip.hover="'Không xác định'"></i>
                  </template>
                </div>
                <div class="wattage-group" v-if="item.code.startsWith('88')">
                  <template v-if="item.loadAc === 1">
                    <i class="mr-2 fa fa-plug" style="font-size: 23px;font-weight: 500;color:#2eb85c"
                      :key="'wattage' + item.id + item.loadAc" v-c-tooltip.hover="'Trạng thái nguồn: Bật'"></i>
                  </template>
                  <template v-else-if="item.loadAc === 0">
                    <i class="mr-2 fa fa-plug" style="font-size: 23px;font-weight: 500;"
                      :key="'wattage' + item.id + item.loadAc" v-c-tooltip.hover="'Trạng thái nguồn: Tắt'"></i>
                  </template>
                  <template v-else>
                    <i class="mr-2 fa fa-ban" style="font-size: 23px;font-weight: 500;"
                      :key="'wattage' + item.id + item.loadAc" v-c-tooltip.hover="'Không xác định'"></i>
                  </template>
                </div>
                <div class="networkType-group">
                  <template v-if="item.networkType === 1">
                    <i class="mr-2 fa fa-wifi" style="font-size: 22px;font-weight: 500;"
                      :key="'netWorkType' + item.id + item.networkType" v-c-tooltip.hover="'Mạng không dây'"></i>
                  </template>
                  <template v-else-if="item.networkType === 0">
                    <CIcon name="cil-lan" class="mr-2" size="lg" :key="'netWorkType' + item.id + item.networkType"
                      v-c-tooltip.hover="'Mạng có dây'" />
                    <!-- <i class="mr-2 fa fa-desktop" style="font-size: 22px;font-weight: 500;"
                      :key="'netWorkType' + item.id + item.networkType" v-c-tooltip.hover="'Mạng có dây'"></i> -->
                    <!-- <svg width="25px" height="25px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" class="mr-2"
                      v-c-tooltip.hover="'Mạng có dây'" :key="'networkType' + item.code + item.networkType"
                      style="margin-top: -3px">
                      <g id="Layer_2">
                        <g id="invisible_box" data-name="invisible box">
                          <rect width="24" height="24" fill="none" />
                        </g>
                        <g id="horoscope">
                          <g>
                            <path
                              d="M25.6,25.6,22.2,29,19,25.8l3.4-3.4a2,2,0,0,0-2.8-2.8L16.2,23l-1.3-1.3a1.9,1.9,0,0,0-2.8,0l-3,3a9.8,9.8,0,0,0-3,7,9.1,9.1,0,0,0,1.8,5.6L4.6,40.6a1.9,1.9,0,0,0,0,2.8,1.9,1.9,0,0,0,2.8,0l3.2-3.2a10.1,10.1,0,0,0,5.9,1.9,10.2,10.2,0,0,0,7.1-2.9l3-3a2,2,0,0,0,.6-1.4,1.7,1.7,0,0,0-.6-1.4L25,31.8l3.4-3.4a2,2,0,0,0-2.8-2.8Z" />
                            <path
                              d="M43.4,4.6a1.9,1.9,0,0,0-2.8,0L37.2,8a10,10,0,0,0-13,.9l-3,3a2,2,0,0,0-.6,1.4,1.7,1.7,0,0,0,.6,1.4L32.9,26.4a1.9,1.9,0,0,0,2.8,0l3-2.9a9.9,9.9,0,0,0,2.9-7.1A10.4,10.4,0,0,0,40,10.9l3.4-3.5A1.9,1.9,0,0,0,43.4,4.6Z" />
                          </g>
                        </g>
                      </g>
                    </svg> -->
                  </template>
                  <template v-else>
                    <i class="mr-2 fa fa-ban" style="font-size: 22px;font-weight: 500;"
                      :key="'netWorkType' + item.id + item.networkType" v-c-tooltip.hover="'Chưa xác định'"></i>
                  </template>
                </div>
                <i class="mr-2 fa fa-tachometer" style="font-size: 22px;font-weight: 500;"
                  v-if="($hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_MANAGEMENT')) && item.acVolt !== null && item.acVolt !== undefined && item.acVolt !== '' && Number(item.acVolt) !== 0"
                  :key="'acVolt' + item.id + item.acVolt"
                  :style="{
                    fontSize: '22px',
                    fontWeight: 500,
                    color: (Number(item.acVolt) <= 130 || Number(item.acVolt) >= 260)
                      ? '#e55353'
                      : ((Number(item.acVolt) >= 200 && Number(item.acVolt) <= 240) ? '#2eb85c' : '#f9b115')
                  }"
                  v-c-tooltip.hover="'Điện áp AC: ' + item.acVolt + 'V'
                    + ((Number(item.acVolt) <= 130)
                      ? ' - Điện áp yếu'
                      : ((Number(item.acVolt) >= 260)
                        ? ' - Điện áp cao'
                      : ((Number(item.acVolt) >= 200 && Number(item.acVolt) <= 240)
                        ? ''
                        : '')))"></i>
                <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
                <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
              </div>

            </td>
          </template>
          <template #locationName="{ item }">
            <td>
              <span class="badge "
                :class="(item.locationName != null && item.locationName != '') ? 'badge-light' : 'badge-danger'">
                {{ (item.locationName != null && item.locationName != '') ? item.locationName : 'Chưa gán' }}</span>
            </td>
          </template>
          <template #version="{ item }">
            <td>
              <span class="badge badge-light">
                {{ item.version }}
              </span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <CDropdown color="secondary" :placement="actionDropdownPlacement" addMenuClasses="action-table-dropdown-menu"
                :customPopperOptions="actionDropdownPopperOptions">
                <template #toggler-content>
                  <i class="fa fa-list-ul" style="font-size: 18px!important;"></i>
                </template>
                <CDropdownItem v-if="item.type == 0 && !$hasAuthor('ROLE_MANAGEMENT_DEVICE')" @click="clickStopContent(item.id, false)" class="action-dropdown-item">
                  <i class="fa fa-stop mr-2"></i> Dừng phát thanh
                </CDropdownItem>
                <CDropdownItem @click="restartDevice(item.id)" class="action-dropdown-item">
                  <i class="fa fa-power-off mr-2"></i> Khởi động lại thiết bị
                </CDropdownItem>
                <CDropdownItem @click="setupSelectOneAction('action_one', item.id, item.code, null, typeActionList.GET_STATUS)" class="action-dropdown-item">
                  <i class="fa fa-retweet mr-2"></i> Đồng bộ dữ liệu
                </CDropdownItem>
                <CDropdownItem v-if="item.type == 0" @click="setupSelectOneAction('on_off_wattage', item.id, item.code, null, item.wattage)" class="action-dropdown-item">
                  <i class="fa fa-bolt mr-2"></i> {{ item.wattage == 0 ? 'Bật công suất' : 'Tắt công suất' }}
                </CDropdownItem>
                <CDropdownItem @click="setupConfigInformation(item)" class="action-dropdown-item">
                  <i class="fa fa-cogs mr-2"></i> Cấu hình thiết bị
                </CDropdownItem>
                <CDropdownItem @click="openGoogleMapDirections(item)" class="action-dropdown-item">
                  <i class="fa fa-map-marker mr-2"></i> Mở bản đồ
                </CDropdownItem>
                <CDropdownItem v-if="item.code.startsWith('88')" @click="setupSelectOneAction('on_off_load_ac', item.id, item.code, null, item.loadAc)" class="action-dropdown-item">
                  <i class="fa fa-plug mr-2"></i> {{ item.loadAc == 0 ? 'Bật nguồn' : 'Tắt nguồn' }}
                </CDropdownItem>
                <CDropdownItem v-if="item.code.startsWith('88')" @click="configTimeOnOffAC(item)" class="action-dropdown-item">
                  <i class="fa fa-clock-o mr-2"></i> Cấu hình thời gian bật tắt nguồn ra
                </CDropdownItem>
                <CDropdownItem v-if="($hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')) && item.type == 0" @click="setupSelectOneAction('check_sound_speaker', item.id, item.code)" class="action-dropdown-item">
                  <i class="fa fa-volume-up mr-2"></i> Kiểm tra âm thanh
                </CDropdownItem>
                <template v-if="$hasAuthor('ROLE_MANAGEMENT')">
                  <CDropdownItem v-if="item.locationCode" @click="setupChangeDevice(item)" class="action-dropdown-item">
                    <i class="fa fa-exchange mr-2"></i> Thay đổi thiết bị
                  </CDropdownItem>
                  <CDropdownItem @click="setupSelectOneAction('reset_default', item.id, item.code, null, item.wattage)" class="action-dropdown-item">
                    <i class="fa fa-refresh mr-2"></i> Reset mặc định
                  </CDropdownItem>
                  <CDropdownItem @click="setupUpdateFW(item)" class="action-dropdown-item">
                    <i class="fa fa-download mr-2"></i> Cập nhật phần mềm
                  </CDropdownItem>
                </template>
                <template v-if="$hasAuthor('ROLE_ADMIN')">
                  <CDropdownItem @click="setupSelectOneAction('reset_default', item.id, item.code, null, item.wattage)" class="action-dropdown-item">
                    <i class="fa fa-refresh mr-2"></i> Reset mặc định
                  </CDropdownItem>
                  <CDropdownItem v-if="item.type == 0" @click="setupAddPhoneNumber(item)" class="action-dropdown-item">
                    <i class="fa fa-phone mr-2"></i> Thêm SĐT
                  </CDropdownItem>
                  <CDropdownItem @click="getLogDevice(item.id)" class="action-dropdown-item">
                    <i class="fa fa-history mr-2"></i> Lấy LogFile
                  </CDropdownItem>
                  <CDropdownItem @click="setupSelectOneAction('check_temp', item.id, item.code)" class="action-dropdown-item">
                    <i class="fa fa-thermometer-empty mr-2"></i> Kiểm tra nhiệt độ
                  </CDropdownItem>
                  <CDropdownItem v-if="item.locationCode" @click="setupChangeDevice(item)" class="action-dropdown-item">
                    <i class="fa fa-exchange mr-2"></i> Thay đổi thiết bị
                  </CDropdownItem>
                  <CDropdownItem @click="setupAttachImage(item)" class="action-dropdown-item">
                    <i class="fa fa-image mr-2"></i> Ảnh đính kèm
                  </CDropdownItem>
                  <CDropdownItem v-if="item.type == 1" @click="configBitrate(item)" class="action-dropdown-item">
                    <i class="fa fa-beer mr-2"></i> Cấu hình Bitrate
                  </CDropdownItem>
                  <CDropdownItem @click="setupConfigAuthentication(item)" class="action-dropdown-item">
                    <i class="fa fa-lock mr-2"></i> Cấu hình xác thực
                  </CDropdownItem>
                  <CDropdownItem @click="setupMonitorConfig(item)" class="action-dropdown-item">
                    <i class="fa fa-eye mr-2"></i> Cấu hình theo dõi
                  </CDropdownItem>
                  <CDropdownItem @click="setupUpdateFW(item)" class="action-dropdown-item">
                    <i class="fa fa-download mr-2"></i> Cập nhật phần mềm
                  </CDropdownItem>
                  <CDropdownItem @click="setupATCommand(item)" class="action-dropdown-item">
                    <i class="fa fa-comment mr-2"></i> Send Command
                  </CDropdownItem>
                  <CDropdownItem @click="setupSelectOneAction('delete_one', item.id, item.code)" class="action-dropdown-item action-dropdown-item--danger">
                    <CIcon name="cil-trash" class="mr-2" /> Xóa
                  </CDropdownItem>
                </template>
                <template v-else-if="$hasAuthor('ROLE_MANAGEMENT_DEVICE')">
                  <CDropdownItem v-if="item.type == 0" @click="setupSelectOneAction('check_sound_speaker', item.id, item.code)" class="action-dropdown-item">
                    <i class="fa fa-volume-up mr-2"></i> Kiểm tra âm thanh
                  </CDropdownItem>
                  <CDropdownItem @click="setupUpdateFW(item)" class="action-dropdown-item">
                    <i class="fa fa-download mr-2"></i> Cập nhật phần mềm
                  </CDropdownItem>
                  <CDropdownItem v-if="item.locationCode" @click="setupChangeDevice(item)" class="action-dropdown-item">
                    <i class="fa fa-exchange mr-2"></i> Thay đổi thiết bị
                  </CDropdownItem>
                  <CDropdownItem @click="setupAttachImage(item)" class="action-dropdown-item">
                    <i class="fa fa-image mr-2"></i> Ảnh đính kèm
                  </CDropdownItem>
                </template>
              </CDropdown>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <BaseModal title="Cập nhật phần mềm" :isFooter="true" :show.sync="dataUpdateFW.isShowModalUpdateFW"
      :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataUpdateFW.versionSelect.options" :data="dataUpdateFW.versionSelect.data"
            ref="versionSelect"></BaseSelect>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="dataUpdateFW.isShowModalUpdateFW = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitUpdateFW()"><i class="fa fa-check"></i> Thực hiện
        </button>
      </template>
    </BaseModal>

    <BaseModal title="Cấu hình Bitrate" :isFooter="true" :show.sync="dataConfigBitrate.isShowModal"
      :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataConfigBitrate.bitrateSelect.options" :data="dataConfigBitrate.bitrateSelect.data"
            ref="bitrateSelect"></BaseSelect>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="dataConfigBitrate.isShowModal = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitConfigBitrate()"><i class="fa fa-check"></i> Thực
          hiện
        </button>
      </template>
    </BaseModal>

    <BaseModal title="Cấu hình thời gian bật tắt nguồn ra" :isFooter="true" :show.sync="dataConfigTimeOnOffAC.isShowModal"
      :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sx="12" sm="12" md="12" lg="12" xl="12" v-for="(each, index) in dataConfigTimeOnOffAC.timeRange"
            :key="index+'unique'+each.start.getTime()">
          <DatePicker mode="time" :masks="{ input: 'HH:MM', data: 'HH:MM' }" :value="each" is-range
            is24hr :popover="{ visibility: 'click' }" @input="changeTimeRange($event, index)"
            ref="timeRange">
            <template v-slot="{ inputValue, inputEvents }">
              <div class="form-group">
                <input type="text" :style="each.isValid ? 'border-color:red!important;' : ''"
                  class="btn-time-ranger form-control"
                  :value="inputValue.start + ' - ' + inputValue.end" readonly
                  v-on="inputEvents.start">
              </div>
              <svg v-c-tooltip.hover="'Xóa'" class="w-1 h-1 btn-remove-time" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2" @click="removeTimeRange(index)">
                <path d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </template>
          </DatePicker>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CButton color="primary" class="mt-3" @click="addTimeRange()">
            <i class="fa fa-plus"></i> Thêm
          </CButton>
          <CButton color="secondary" class="mt-3 ml-2" @click="sortRangeTime(true)">
            <i class="fa fa-sort"></i> Sắp xếp
          </CButton>
          <CButton color="secondary" class="mt-3 ml-2" @click="dataConfigTimeOnOffAC.timeRange = []">
            <i class="fa fa-eraser"></i> Xóa tất cả
          </CButton>
        </CCol>
      </CRow>
      <CRow>
        <div class="valid-error" v-show="dataConfigTimeOnOffAC.errorMessage && dataConfigTimeOnOffAC.errorMessage != ''">
          {{ dataConfigTimeOnOffAC.errorMessage }}
        </div>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="dataConfigTimeOnOffAC.isShowModal = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitConfigTimeOnOffAC()"><i class="fa fa-check"></i> Thực
          hiện
        </button>
      </template>
    </BaseModal>

    <BaseModal title="Thay đổi âm lượng các thiết bị" :isFooter="false"
      :show.sync="isShowModalChangeVolumeMultipleDevice" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <span style="display: flex;justify-content: center; font-weight: 500;font-size: 20px;">
            {{ volumeChangeMultipleDevice }}</span>
          <range-slider class="slider" min="0" max="100" step="5" v-model="volumeChangeMultipleDevice"
            style="width: 100%;max-width: unset" @change="changeVolume(null, volumeChangeMultipleDevice, true)">
          </range-slider>
        </CCol>
      </CRow>
    </BaseModal>

    <CModal v-if="modelShowSchedulePlaying.isShow"
      :title="'Nội dung đang phát: ' + modelShowSchedulePlaying.selectedDevice"
      :show.sync="modelShowSchedulePlaying.isShow" :closeOnBackdrop="false">
      <CRow class="content-fade-in" v-if="modelShowSchedulePlaying.details != null">
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">Người tạo lịch: </span>{{
                      modelShowSchedulePlaying.details.createUserName
                    }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">Địa bàn tạo: </span>{{
                        modelShowSchedulePlaying.details.locationName
                      }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">{{ modelShowSchedulePlaying.details.playListId ? 'Danh sách phát:' :
                      'Tên tệp tin: '}} </span>{{
                        modelShowSchedulePlaying.details.title
                      }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">Ngày tạo: </span>{{
                        $helper.formatDateDDMMYYYYHHMM(modelShowSchedulePlaying.details.createDate)
                      }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">Bắt đầu từ: </span>{{
                        modelShowSchedulePlaying.details.mode == 3 ? $helper.formatDate(modelShowSchedulePlaying.details.fromDate) :
                          $helper.formatDate(modelShowSchedulePlaying.details.startTime)
                      }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2" v-if="modelShowSchedulePlaying.details.mode != 3">
          <label><span style="font-weight: bold">Kết thúc lúc: </span>
            {{ $helper.formatDate(modelShowSchedulePlaying.details.endTime) }}
          </label>
          <div class="mt-2">
            <label><span style="font-weight: bold">Nội dung: </span>
              <span v-c-tooltip.hover="'Ấn để xem tệp'" @click="previewFile()" class="previewFile">Ấn để xem tệp</span>
            </label>
          </div>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2" v-if="modelShowSchedulePlaying.details.mode == 3">
          <label><span style="font-weight: bold">Trực tiếp: </span> <span class="blink"> Live</span></label>
        </CCol>
      </CRow>
      <CRow class="content-fade-in" v-else>
        <CCol>
          Không có nội dung nào đang phát!
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="modelShowSchedulePlaying.isShow = false"><i
            class="fa fa-times"></i> Đóng
        </button>
      </template>
    </CModal>

    <CModal title="Cấu hình thông tin cho thiết bị" :show.sync="isShowModalConfigInformation" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12" v-show="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_MANAGEMENT')">
          <BaseSelect :options="dataSetInformationDevice.locationLevelSelect.options"
            :data="dataSetInformationDevice.locationLevelSelect.data" ref="dataSetLocationLocationLevelSelect">
          </BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" v-show="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_MANAGEMENT')">
          <BaseSelect :options="dataSetInformationDevice.locationCodeSelect.options"
            :data="dataSetInformationDevice.locationCodeSelect.data" ref="dataSetLocationLocationCodeSelect">
          </BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" v-show="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_MANAGEMENT')">
          <BaseSelect :options="dataSetInformationDevice.supplierSelect.options"
            :data="dataSetInformationDevice.supplierSelect.data" ref="dataSetSupplierSelect">
          </BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" v-show="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_MANAGEMENT')">
          <BaseInput :options="dataSetInformationDevice.longitudeInput.options"
            :data="dataSetInformationDevice.longitudeInput.data" />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" v-show="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_MANAGEMENT')">
          <BaseInput :options="dataSetInformationDevice.latitudeInput.options"
            :data="dataSetInformationDevice.latitudeInput.data" />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" v-if="dataSetInformationDevice.type == 0"
          v-show="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_MANAGEMENT')">
          <div class="form-group">
            <label>{{ dataSetInformationDevice.speakerConf.options.label }}&nbsp;<span class="required">*</span></label>
            <div class="mt-1">
              <template v-for="(speaker, index) in dataSetInformationDevice.speakerConf.data.model">
                <CInputCheckbox custom @update:checked="checkBoxSpeakerConf($event, index)" :checked="speaker"
                  :inline="true" />
              </template>
              <div class="valid-error"
                v-show="!(dataSetInformationDevice.speakerConf.data.validator ? dataSetInformationDevice.speakerConf.data.validator.isValid : true)">
                {{
                      dataSetInformationDevice.speakerConf.data.validator ?
                        dataSetInformationDevice.speakerConf.data.validator.errorMessage : ""
                    }}
              </div>
            </div>
          </div>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseTextArea :options="dataSetInformationDevice.descriptionInput.options"
            :data="dataSetInformationDevice.descriptionInput.data"
            v-model="dataSetInformationDevice.descriptionInput.data.model" />
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalConfigInformation = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitConfigInformation()"><i class="fa fa-check"></i> Cấu
          hình
        </button>
      </template>
    </CModal>
    <CModal v-if="isShowModalConfigAuthentication" title="Cấu hình thông tin xác thực"
      :show.sync="isShowModalConfigAuthentication" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <span class="required font-weight-bold">Chú ý: Thay đổi thông tin này cần người nắm được nghiệp vụ về hệ
            thống.
            Nếu không vui lòng không thực hiện
            thao tác này!</span>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataSubmitConfigAuthentication.authenServerSelect.options"
            :data="dataSubmitConfigAuthentication.authenServerSelect.data" ref="authenServerSelect"></BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <div class="form-group">
            <label>Stun Server</label>
            <div>
              <template v-for="each in dataConfigAuthentication.stunsServer">
                <span class="badge badge-light mr-1">{{ each }}</span>
              </template>
            </div>
          </div>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <div class="form-group">
            <label>Turn Server</label>
            <div>
              <template v-for="each in dataConfigAuthentication.turnsServer">
                <span class="badge badge-light mr-1"> {{ each.server }} - {{ each.user }}/{{ each.cred }}</span>
              </template>
            </div>
          </div>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <div class="form-group">
            <label>Bật/Tắt Gửi LOG</label>
            <div>
              <CInputCheckbox custom :checked="dataConfigAuthentication.enablePutLog"
                @update:checked="updateStateEnableLog($event)" />
            </div>
          </div>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalConfigAuthentication = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitConfigAuthentication()"><i class="fa fa-check"></i>
          Cấu hình
        </button>
      </template>
    </CModal>

    <BaseModal v-if="isShowModalATCommand" :title="`Command: ${showATCmdModel.code}`"
      :isFooter="false" :size="'lg'" :show.sync="isShowModalATCommand" :closeOnBackdrop="false" id="12">
      <BaseFormATCommand :phoneNumber="showATCmdModel.phoneNumber" :deviceId="showATCmdModel.deviceId">
      </BaseFormATCommand>
    </BaseModal>

    <BaseModal title="Dừng phát nội dung" :isFooter="true" :show.sync="isShowModalStopContent" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="stopContentSelect.options" :data="stopContentSelect.data" ref="stopContentSelect">
          </BaseSelect>
        </CCol>
      </CRow>
      <template slot="footer">
        <CButton color="secondary" class="btn-action-primary" @click="isShowModalStopContent = false"><i
            class="fa fa-remove"></i> Hủy bỏ
        </CButton>
        <CButton color="primary" class="btn-action-primary" @click="submitDataStopContent()">
          <i class="fa fa-check"></i> Thực hiện
        </CButton>
      </template>
    </BaseModal>


    <CModal v-if="isShowModalExchangeDevice" :size="'xl'" :title="'Thay đổi thiết bị: ' + dataExchangeDevice.code + ' - ' + dataExchangeDevice.description"
      :show.sync="isShowModalExchangeDevice" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <DeviceFreeForExchange @device:selected="deviceExchangeSelected($event)" :type="dataExchangeDevice.type" :locationCode="dataExchangeDevice.locationCode">
          </DeviceFreeForExchange>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalExchangeDevice = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button :disabled="dataExchangeDevice.id == '' || dataExchangeDevice.idExchange == ''" type="button"
          class="btn btn-primary" @click="submitExchangeDevice()">
          <i class="fa fa-check"></i> Thay đổi
        </button>
      </template>
    </CModal>

    <CModal v-if="dataAddPhoneNumber.isShowModal" :title="'Thêm mới SĐT: ' + dataAddPhoneNumber.code"
      :show.sync="dataAddPhoneNumber.isShowModal" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput :options="dataAddPhoneNumber.phoneNumberInput.options"
            :data="dataAddPhoneNumber.phoneNumberInput.data" />
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="dataAddPhoneNumber.isShowModal = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button :disabled="dataAddPhoneNumber.id == ''" type="button" class="btn btn-primary"
          @click="submitAddPhoneNumber()">
          <i class="fa fa-check"></i> Thay đổi
        </button>
      </template>
    </CModal>

    <CModal v-if="dataTestSpeakerDigital.isShowModal"
      :title="'Kiểm tra loa link số hóa: ' + dataTestSpeakerDigital.deviceCode"
      :show.sync="dataTestSpeakerDigital.isShowModal" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataTestSpeakerDigital.channelDigitalSelect.options"
            :data="dataTestSpeakerDigital.channelDigitalSelect.data" ref="testSpeakerChannelDigitalSelect" />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" class="mt-2">
          <BaseSelect :options="dataTestSpeakerDigital.durationSelect.options"
            :data="dataTestSpeakerDigital.durationSelect.data" ref="testSpeakerDurationSelect" />
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="dataTestSpeakerDigital.isShowModal = false">
          <i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitDigitalSpeakerTest()">
          <i class="fa fa-check"></i> Xác nhận
        </button>
      </template>
    </CModal>

    <CModal v-if="monitorView.isShow" :title="'Theo dõi thiết bị: ' + monitorView.code"
      :show.sync="monitorView.isShow" :closeOnBackdrop="true">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12" class="mb-2">
          <label class="font-weight-bold d-block mb-1">Mức theo dõi</label>
          <span v-if="monitorView.monitorLevel == 1" class="badge badge-warning">Cần theo dõi</span>
          <span v-else-if="monitorView.monitorLevel == 2" class="badge badge-danger">Cảnh báo cao</span>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" class="mb-2">
          <label class="font-weight-bold d-block mb-1">Lý do</label>
          <div class="monitor-view-reason">{{ monitorView.monitorReason || '—' }}</div>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" v-if="monitorView.monitorAt || monitorView.monitorBy">
          <small class="text-muted">
            <span v-if="monitorView.monitorAt">Cập nhật: {{ $helper.formatDateDDMMYYYYHHMM(monitorView.monitorAt) }}</span>
            <span v-if="monitorView.monitorBy"> · {{ monitorView.monitorBy }}</span>
          </small>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="monitorView.isShow = false">
          <i class="fa fa-times"></i> Đóng
        </button>
      </template>
    </CModal>

    <CModal v-if="dataDeviceMonitor.isShowModal" :title="'Cấu hình theo dõi: ' + dataDeviceMonitor.code"
      :show.sync="dataDeviceMonitor.isShowModal" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataDeviceMonitor.monitorLevelSelect.options"
            :data="dataDeviceMonitor.monitorLevelSelect.data" ref="deviceMonitorLevelSelect" />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" class="mt-2">
          <BaseTextArea :options="dataDeviceMonitor.monitorReasonInput.options"
            :data="dataDeviceMonitor.monitorReasonInput.data"
            v-model="dataDeviceMonitor.monitorReasonInput.data.model" />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" class="mt-2" v-if="dataDeviceMonitor.monitorAt">
          <small class="text-muted">
            Cập nhật lúc: {{ $helper.formatDateDDMMYYYYHHMM(dataDeviceMonitor.monitorAt) }}
            <span v-if="dataDeviceMonitor.monitorBy"> bởi {{ dataDeviceMonitor.monitorBy }}</span>
          </small>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="dataDeviceMonitor.isShowModal = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button :disabled="!dataDeviceMonitor.id" type="button" class="btn btn-primary"
          @click="submitMonitorConfig()">
          <i class="fa fa-check"></i> Lưu
        </button>
      </template>
    </CModal>

    <CModal title="Ảnh đính kèm" :size="'xl'" :show.sync="isShowModalAttachImage" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <template v-if="dataAttachImage.images.length > 0">
          <template v-for="(image, index) in dataAttachImage.images">
            <CCol sm="12" md="12" xl="3" xs="12" class="mb-3">
              <div>
                <img class="attachImage" :src="image" alt="" @click="showDetailImage(image)" />
                <i class="fa fa-close editAttachImage" v-c-tooltip.hover="'Xóa'"
                  @click="removeAttachImage(image, index)"></i>
              </div>
            </CCol>
          </template>
        </template>
        <CCol sm="12" md="3" xl="3" xs="12" v-if="dataAttachImage.images.length < 4">
          <label class="label">
            <i class="fa fa-file"></i>
            <span class="title">Thêm Ảnh</span>
            <input type="file" accept=".jpg, .jpeg, .png" multiple @change="selectFile($event)" />
          </label>
        </CCol>
        <div class="lightbox" v-if="showDetailUrl != ''" @click="showDetailUrl = ''">
          <img :src="showDetailUrl" alt="" class="content-fade-in">
        </div>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalAttachImage = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitAttachImage()"><i class="fa fa-check"></i> Cập
          nhật
        </button>
      </template>
    </CModal>

    <BaseModal title="Bật/Tắt công suất" :isFooter="true" :show.sync="isShowModalOnOffWattage" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="onOffWattageSelect.options" :data="onOffWattageSelect.data" ref="onOffWattageSelect">
          </BaseSelect>
        </CCol>
      </CRow>
      <template slot="footer">
        <CButton color="secondary" class="btn-action-primary" @click="isShowModalOnOffWattage = false"><i
            class="fa fa-remove"></i> Hủy bỏ
        </CButton>
        <CButton color="primary" class="btn-action-primary" @click="submitDataOnOffWattage()">
          <i class="fa fa-check"></i> Thực hiện
        </CButton>
      </template>
    </BaseModal>

    <CModal v-if="hereMapModal.isShow" title="Bản đồ"
      :show.sync="hereMapModal.isShow" :closeOnBackdrop="false" size="xl">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <HereMap v-if="hereMapModal.isShow"></HereMap>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="hereMapModal.isShow = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
      </template>
    </CModal>

    <CModal v-if="dataImport.isShowModal" :title="'Cập nhật NCC theo mã thiết bị'" :show.sync="dataImport.isShowModal"
        :closeOnBackdrop="false">
        <CRow class="pb-2">
            <CCol sm="12" md="12" xl="12" xs="12">
              <BaseSelect :options="dataImport.supplierSelect.options" :data="dataImport.supplierSelect.data"
                ref="dataImportForNCCSelect"></BaseSelect>
            </CCol>
            <CCol sm="12" md="12" xl="12" xs="12" class="form-group">
                <div class="form-input-wrapper">
                    <label class="form-label" for="uploadFile">Chọn tệp tin<span class='required'> *</span></label>
                    <div class="custom-file"
                        :class="dataImport.selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                        <input type="file" class="custom-file-input" id="uploadFile" ref="file"
                            :accept="dataImport.selectedFiles.options.acceptFile" @change="selectFileNCC($event)">
                        <label class="custom-file-label" for="uploadFile">{{
                            dataImport.selectedFiles.options.fileName
                            }}
                            <i v-if="dataImport.selectedFiles.data.loading" class="fa fa-spinner fa-spin"
                                style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
                        </label>
                    </div>
                    <div class="valid-error"
                        v-show="!(dataImport.selectedFiles.data.validator ? dataImport.selectedFiles.data.validator.isValid : true)">
                        {{ dataImport.selectedFiles.data.validator ?
                            dataImport.selectedFiles.data.validator.errorMessage : "" }}
                    </div>
                </div>
            </CCol>
        </CRow>
        <template v-slot:footer>
            <button type="button" class="btn btn-secondary" @click="dataImport.isShowModal = false"><i
                    class="fa fa-times"></i> Hủy bỏ
            </button>
            <button type="button" class="btn btn-primary" @click="submitImport()"><i class="fa"
                    :class="'fa-upload'"></i> Thực
                hiện
            </button>
        </template>
    </CModal>

    <BaseFormPreview v-if="modelShowSchedulePlaying.isShowModalPreview" :title="modelShowSchedulePlaying.details.title"
      :url="modelShowSchedulePlaying.details.url" :play-list-id="modelShowSchedulePlaying.details.playListId"
      @close-modal="modelShowSchedulePlaying.isShowModalPreview = false"></BaseFormPreview>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import { STYLE_SHOW_DEVICE, TypeActionFileList } from '../../constant';
import { DatePicker } from "v-calendar";
import BaseModal from "@/views/base/BaseModal";
import DeviceFreeForExchange from "@/views/base/DeviceFreeForExchange";
import BaseFormATCommand from "@/views/base/BaseFormATCommand";
import BaseFormPreview from "@/views/base/BaseFormPreview";
import HereMap from "@/views/devices/HereMap";

export default {
  name: "DeviceList",
  components: {
    BaseFormPreview,
    BaseFormATCommand,
    DeviceFreeForExchange,
    BaseModal,
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseSwitch,
    ModalConfirm,
    BaseTextArea,
    BaseFormLoading,
    RangeSlider,
    DatePicker,
    HereMap
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/devices/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return { id: that.actionData.model.deviceSelectedId };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: "Xóa thiết bị " + that.actionData.model.deviceSelectedName + " thành công" });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("stop_broadcasting", {
      url: "/devices/stop_broadcasting",
      titlePopup: function () {
        return that.$helper.setupTitleAction("dừng phát thanh", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isShowWarningContent: true,
      warningContentPopup: function () {
        return '(Dừng phát thanh trên thiết bị có thể làm gián đoạn bản tin được đặt từ cấp trên, bao gồm cả bản tin thường và bản tin khẩn cấp, vui lòng kiểm tra lịch phát trước khi dừng phát thanh trên thiết bị. Người dùng dừng phát thanh sẽ chịu hoàn toàn trách nhiệm cho thao tác này.)'
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return { id: that.actionData.model.deviceSelectedId };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: "Đã gửi lệnh dừng phát thanh thiết bị " + that.actionData.model.deviceSelectedName + " thành công" });
        that.loadDataMainTable();
      }
    });

    // actionTypeMapping.set("update_app", {
    //   url: "/devices/update-app",
    //   titlePopup: function () {
    //     return that.$helper.setupTitleAction("cập nhật phần mềm", "thiết bị", that.actionData.model.deviceSelectedName);
    //   },
    //   isJsonContentType: false,
    //   dataSubmit: function () {
    //     return { id: that.actionData.model.deviceSelectedId };
    //   },
    //   successCallback: function () {
    //     that.actionData.model.listUserSelectedId = [];
    //     that.showSuccessMsg({ message: "Đã gửi lệnh cập nhật phần mềm " + that.actionData.model.deviceSelectedName + " thành công" });
    //     that.loadDataMainTable();
    //   }
    // });

    actionTypeMapping.set("check_sound_speaker", {
      url: "/devices/check-sound-speaker",
      titlePopup: function () {
        return that.$helper.setupTitleAction("kiểm tra âm thanh", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return { id: that.actionData.model.deviceSelectedId };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: "Đã gửi lệnh kiểm tra âm thanh " + that.actionData.model.deviceSelectedName + " thành công" });
        // that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("check_temp", {
      url: "/devices/check-temp",
      titlePopup: function () {
        return that.$helper.setupTitleAction("kiểm tra nhiệt độ", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return { id: that.actionData.model.deviceSelectedId };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: "Đã gửi lệnh kiểm tra nhiệt độ " + that.actionData.model.deviceSelectedName + " thành công" });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("on_off_wattage", {
      url: "/devices/onOffWattage",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.type == 0 ? "bật công suất" : "tắt công suất", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.deviceSelectedId,
          ids: [],
          type: ''
        };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: `Đã gửi lệnh ${that.actionData.model.type == 0 ? "bật" : "tắt"} công suất thiết bị ${that.actionData.model.deviceSelectedName} thành công` });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("reset_default", {
      url: "/devices/resetDefault",
      titlePopup: function () {
        return that.$helper.setupTitleAction("reset mặc định", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          deviceId: that.actionData.model.deviceSelectedId,
        };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: "Đã gửi lệnh reset mặc định " + that.actionData.model.deviceSelectedName + " thành công" });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("on_off_load_ac", {
      url: "/devices/onOffLoadAc",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.type == 0 ? "bật nguồn ra" : "tắt nguồn ra", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.deviceSelectedId,
          ids: [],
          type: ''
        };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({ message: `Đã gửi lệnh ${that.actionData.model.type == 0 ? "bật" : "tắt"} nguồn ra thiết bị ${that.actionData.model.deviceSelectedName} thành công` });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("action_list", {
      url: "/devices/actionList",
      titlePopup: function () {
        switch (that.actionData.model.type) {
          case TypeActionFileList.DELETE_LIST: {
            return that.$helper.setupTitleAction("xóa", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.RESTART_LIST: {
            return that.$helper.setupTitleAction("khởi động lại", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.UPDATE_APP_LIST: {
            return that.$helper.setupTitleAction("cập nhật phần mềm", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.STOP_BROADCASTING: {
            return that.$helper.setupTitleAction("dừng phát thanh", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.CHECK_TEMPERATURE: {
            return that.$helper.setupTitleAction("kiểm tra nhiệt độ", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.GET_STATUS: {
            return that.$helper.setupTitleAction("đồng bộ dữ liệu", "các thiết bị", "đã chọn");
          }
        }
      },
      isShowWarningContent: true,
      warningContentPopup: function () {
        switch (that.actionData.model.type) {
          case TypeActionFileList.STOP_BROADCASTING: {
            return '(Dừng phát thanh trên thiết bị có thể làm gián đoạn bản tin được đặt từ cấp trên, bao gồm cả bản tin thường và bản tin khẩn cấp, vui lòng kiểm tra lịch phát trước khi dừng phát thanh trên thiết bị. Người dùng dừng phát thanh sẽ chịu hoàn toàn trách nhiệm cho thao tác này.)';
          }
        }
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          ids: that.actionData.model.listDeviceSelectedId,
          type: that.actionData.model.type
        };
      },
      successCallback: function () {
        that.actionData.model.listDeviceSelectedId = [];
        switch (that.actionData.model.type) {
          case TypeActionFileList.DELETE_LIST: {
            that.showSuccessMsg({ message: "Xóa các thiết bị thành công" });
            break;
          }
          case TypeActionFileList.RESTART_LIST: {
            that.showSuccessMsg({ message: "Thực hiện thao tác khởi động lại các thiết bị thành công" });
            break;
          }
          case TypeActionFileList.UPDATE_APP_LIST: {
            that.showSuccessMsg({ message: "Thực hiện thao tác cập nhật phần mềm các thiết bị thành công" });
            break;
          }
          case TypeActionFileList.CHECK_TEMPERATURE: {
            that.showSuccessMsg({ message: "Thực hiện thao tác kiểm tra nhiệt độ các thiết bị thành công" });
            break;
          }
          case TypeActionFileList.GET_STATUS: {
            that.showSuccessMsg({ message: "Thực hiện thao tác đồng bộ dữ liệu các thiết bị thành công" });
            break;
          }
          case TypeActionFileList.STOP_BROADCASTING: {
            that.showSuccessMsg({ message: "Dừng phát thanh các thiết bị thành công" });
            break;
          }
        }
        that.loadDataMainTable();
      },
    });

    actionTypeMapping.set("action_one", {
      url: "/devices/actionList",
      titlePopup: function () {
        switch (that.actionData.model.type) {
          case TypeActionFileList.GET_STATUS: {
            return that.$helper.setupTitleAction("đồng bộ dữ liệu", "thiết bị", that.actionData.model.deviceSelectedName);
          }
        }
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          ids: [that.actionData.model.deviceSelectedId],
          type: that.actionData.model.type
        };
      },
      successCallback: function () {
        switch (that.actionData.model.type) {
          case TypeActionFileList.GET_STATUS: {
            that.showSuccessMsg({ message: "Thực hiện thao tác đồng bộ dữ liệu thiết bị thành công" });
            break;
          }
        }
        that.loadDataMainTable();
      },
    });

    return {
      loading: { value: false },
      isMobileViewport: false,
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      hereMapModal: {
        loading: false,
        isShow: false
      },
      typeActionList: TypeActionFileList,
      isShowModalChangeVolumeMultipleDevice: false,
      isShowModalStopContent: false,
      isShowModalOnOffWattage: false,
      modelShowSchedulePlaying: {
        isShow: false,
        isShowModalPreview: false,
        selectedDevice: null,
        details: {}
      },
      volumeChangeMultipleDevice: 0,
      dataImport: {
        isShowModal: false,
        supplierSelect: {
          options: {
            filter: true,
            label: "NCC <span class='required'>*</span>",
            selectAllText: "Chọn NCC",
            'keyField': 'key',
            'valueField': 'value',
          },
          data: {
            name: "supplierId",
            items: [],
            model: null,
            source: {
              url: '/supplier/get-list-supplier',
              dataSubmit: function () {
                return {}
              },
              response: function (dataResponse) {
                that.dataImport.supplierSelect.data.items = dataResponse.data;
              }
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataImport.supplierSelect.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "NCC không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            },
          }
        },
        selectedFiles: {
            options: {
                fileName: 'Chọn tệp Excel',
                acceptFile: ".xlsx, .xls",
            },
            data: {
                loading: false,
                name: "file",
                model: {
                    fileName: '',
                    content: '',
                    size: '',
                    type: ''
                },
                validator: {
                    isValid: true,
                    errorMessage: "",
                    valid: function () {
                        this.isValid = that.validateFile();
                        return this.isValid;
                    }
                }
            }
        },
    },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          deviceSelectedId: null,
          deviceSelectedName: null,
          status: null,
          listDeviceSelectedId: [],
          type: null,
          isStopContentAll: false
        }
      },
      codeInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: 'Mã thiết bị'
        },
        data: {
          name: "code",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      descriptionInput: {
        options: {
          placeholder: "Mô tả địa chỉ",
          label: 'Mô tả địa chỉ'
        },
        data: {
          name: "description",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },

      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') || this.$hasAuthor('ROLE_MANAGEMENT_DEVICE') ? false : true,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },

      connectStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái kết nối',
        },
        data: {
          name: "connectStatus",
          items: [
            { key: "-1", value: "Tất cả" },
            { key: "1", value: "Kết nối" },
            { key: "0", value: "Mất kết nối" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      activeStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái hoạt động',
        },
        data: {
          name: "activeStatus",
          items: [
            { key: "-1", value: "Tất cả trạng thái" },
            { key: "0", value: "Đang phát sóng" },
            { key: "1", value: "Tạm dừng phát sóng" },
            { key: "2", value: "Không phát sóng" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },

      locationStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái địa bàn',
        },
        data: {
          name: "isDevice",
          items: [
            { key: "-1", value: "Tất cả" },
            { key: "0", value: "Đã gán" },
            { key: "1", value: "Chưa gán" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      typeDeviceSelect: {
        options: {
          filter: false,
          label: 'Loại thiết bị',
        },
        data: {
          name: "type",
          items: [
            { key: "-1", value: "Tất cả" },
            { key: "0", value: "Truyền thanh cơ sở" },
            { key: "1", value: "Tích hợp tự động" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      monitorLevelSelect: {
        options: {
          filter: false,
          label: 'Mức theo dõi',
        },
        data: {
          name: "monitorLevel",
          items: [
            { key: "-1", value: "Tất cả mức" },
            { key: "0", value: "Bình thường" },
            { key: "1", value: "Cần theo dõi" },
            { key: "2", value: "Cảnh báo cao" },
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      monitorReasonInput: {
        options: {
          placeholder: "Lý do theo dõi",
          label: 'Lý do theo dõi'
        },
        data: {
          name: "monitorReason",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },

      dataUpdateFW: {
        isChangeMultiple: false,
        isShowModalUpdateFW: false,
        id: null,
        versionSelect: {
          options: {
            filter: false,
            label: "Version",
            selectAllText: 'Chọn Version',
            keyField: 'value',
            valueField: 'text'
          },
          data: {
            name: "version",
            items: [],
            model: "",
            // validator: {
            //   isValid: true,
            //   errorMessage: "",
            //   valid: function () {
            //     let value = that.dataUpdateFW.versionSelect.data.model;
            //     if (value == "") {
            //       this.isValid = false;
            //       this.errorMessage = "Vui lòng chọn version";
            //     } else {
            //       this.isValid = true;
            //       this.errorMessage = "";
            //     }
            //     return this.isValid;
            //   }
            // }
          }
        }
      },
      dataConfigBitrate: {
        isShowModal: false,
        id: null,
        bitrateSelect: {
          options: {
            filter: false,
            label: "Version",
            selectAllText: 'Chọn Bitrate',
            // keyField: 'value',
            // valueField: 'text'
          },
          data: {
            name: "version",
            items: [
              { key: '32000', value: '32000' },
              { key: '48000', value: '48000' },
              { key: '64000', value: '64000' },
              { key: '128000', value: '128000' },
              { key: '256000', value: '256000' },
            ],
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataConfigBitrate.bitrateSelect.data.model;
                if (value == "") {
                  this.isValid = false;
                  this.errorMessage = "Vui lòng chọn bitrate";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        }
      },
      dataConfigTimeOnOffAC: {
        isShowModal: false,
        id: null,
        timeRange: [],
        errorMessage: ""
      },
      isShowModalAttachImage: false,
      isShowModalConfigInformation: false,
      isShowModalConfigAuthentication: false,
      dataConfigAuthentication: {},
      dataSubmitConfigAuthentication: {
        id: null,
        authenServerSelect: {
          options: {
            filter: false,
            label: 'Authentication Server',
            'keyField': 'code',
            'valueField': 'description',
            selectAllText: 'Mặc định'
          },
          data: {
            name: "",
            items: [],
            model: "",
          }
        },
        enablePutLog: null
      },
      isShowModalATCommand: false,
      isShowModalExchangeDevice: false,
      showDetailUrl: '',
      showATCmdModel: {
        phoneNumber: '',
        code: '',
        deviceId: ''
      },
      dataTestSpeakerDigital: {
        isShowModal: false,
        deviceId: null,
        deviceCode: '',
        channelDigitalSelect: {
          options: {
            label: "Kênh số hóa <span class='required'>*</span>",
            filter: true,
            lazyLoad: true,
            keyField: 'key',
            valueField: 'value',
            selectAllText: "Chọn kênh số hóa",
          },
          data: {
            name: "channelDigital",
            items: [],
            model: "",
            source: {
              url: '/common/listChannelDigital',
              isJsonContentType: false,
              dataSubmit: function () {
                return {
                  name: '',
                  locationCode: ''
                };
              },
              response: function (dataResponse) {
                const items = dataResponse.data || [];
                that.dataTestSpeakerDigital.channelDigitalSelect.data.items = items;
                if (items.length > 0) {
                  setTimeout(function () {
                    // const selectRef = that.$refs.testSpeakerChannelDigitalSelect;
                    // if (selectRef && typeof selectRef.updateSelectedRender === 'function') {
                    //   selectRef.updateSelectedRender();
                    // }
                    that.dataTestSpeakerDigital.channelDigitalSelect.data.model = items[0].key;
                  }, 100);
                }
              }
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataTestSpeakerDigital.channelDigitalSelect.data.model;
                if (value === "" || value == null) {
                  this.isValid = false;
                  this.errorMessage = "Kênh số hóa không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              },
            },
          },
        },
        durationSelect: {
          options: {
            label: "Thời gian phát thử <span class='required'>*</span>",
            filter: false,
          },
          data: {
            name: "testDurationMinutes",
            items: [
              { key: "3", value: "3 phút" },
              { key: "5", value: "5 phút" },
              { key: "10", value: "10 phút" },
            ],
            model: "5",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataTestSpeakerDigital.durationSelect.data.model;
                if (value === "" || value == null) {
                  this.isValid = false;
                  this.errorMessage = "Thời gian phát thử không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              },
            },
          },
        },
      },
      dataAttachImage: {
        id: null,
        oldImages: [],
        images: [],
        imagesRemove: []
      },
      dataSetInformationDevice: {
        id: null,
        type: null,
        locationLevel: "",
        locationCode: "",
        supplierId: "",
        descriptionInput: {
          options: {
            label: "Mô tả thiết bị",
            placeholder: "Mô tả thiết bị",
            maxlength: 2000,
            rows: 5
          },
          data: {
            name: "description",
            model: "",
          }
        },
        speakerConf: {
          options: {
            label: "Vị trí loa",
          },
          data: {
            name: "speakerConf",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSetInformationDevice.speakerConf.data.model;
                if (that.dataSetInformationDevice.type == 0 && value.filter(each => each === true).length == 0) {
                  this.isValid = false;
                  this.errorMessage = "Tối thiểu phải có 1 vị trí loa được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
        locationLevelSelect: {
          options: {
            filter: false,
            label: 'Cấp địa phương',
            'keyField': 'key',
            'valueField': 'value',
          },
          data: {
            name: "locationLevel",
            items: [],
            model: null,
          },
        },
        locationCodeSelect: {
          options: {
            filter: true,
            label: "Địa phương",
            selectAllText: "Chọn địa phương",
            'keyField': 'key',
            'valueField': 'value',
            lazyLoad: true
          },
          data: {
            name: "locationCode",
            items: [],
            model: null,
            source: {
              url: '/common/findAllLocationByLevel',
              dataSubmit: function () {
                return {
                  level: that.dataSetInformationDevice.locationLevelSelect.data.model
                }
              },
              isJsonContentType: false,
              response: function (dataResponse) {
                that.dataSetInformationDevice.locationCodeSelect.data.items = dataResponse.data;
                that.isShowModalConfigInformation = true;
                setTimeout(() => {
                  that.dataSetInformationDevice.locationCodeSelect.data.model = that.dataSetInformationDevice.locationCode;
                }, 100)
              }
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSetInformationDevice.locationCodeSelect.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Địa phương không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
        supplierSelect: {
          options: {
            filter: true,
            label: "NCC",
            selectAllText: "Chọn NCC",
            'keyField': 'key',
            'valueField': 'value',
            lazyLoad: true
          },
          data: {
            name: "supplierId",
            items: [],
            model: null,
            source: {
              url: '/supplier/get-list-supplier',
              response: function (dataResponse) {
                that.dataSetInformationDevice.supplierSelect.data.items = dataResponse.data;
                setTimeout(() => {
                  that.dataSetInformationDevice.supplierSelect.data.model = that.dataSetInformationDevice.supplierId;
                }, 100)
              }
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSetInformationDevice.locationCodeSelect.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Địa phương không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
        longitudeInput: {
          options: {
            placeholder: "Kinh độ",
            label: 'Kinh độ'
          },
          data: {
            name: "longitude",
            model: ""
          }
        },
        latitudeInput: {
          options: {
            placeholder: "Vĩ độ",
            label: 'Vĩ độ'
          },
          data: {
            name: "latitude",
            model: ""
          }
        },
      },
      dataExchangeDevice: {
        id: '',
        code: '',
        idExchange: '',
        type: '',
        locationCode: ''
      },
      dataAddPhoneNumber: {
        id: '',
        code: '',
        isShowModal: false,
        phoneNumberInput: {
          options: {
            placeholder: "Số điện thoại",
            label: 'Số điện thoại <span class=\'required\'>*</span>'
          },
          data: {
            name: "phoneNumber",
            model: "",
            updateCallback: function () {
              that.submitAddPhoneNumber();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataAddPhoneNumber.phoneNumberInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Số điện thoại không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          },
        },
      },
      monitorView: {
        isShow: false,
        code: '',
        monitorLevel: null,
        monitorReason: '',
        monitorAt: null,
        monitorBy: '',
      },
      dataDeviceMonitor: {
        id: '',
        code: '',
        monitorAt: null,
        monitorBy: '',
        isShowModal: false,
        monitorLevelSelect: {
          options: {
            filter: false,
            label: 'Mức theo dõi <span class=\'required\'>*</span>',
          },
          data: {
            name: "monitorLevel",
            items: [
              { key: "0", value: "Bình thường" },
              { key: "1", value: "Cần theo dõi" },
              { key: "2", value: "Cảnh báo cao" },
            ],
            model: "0",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataDeviceMonitor.monitorLevelSelect.data.model;
                if (value === "" || value == null) {
                  this.isValid = false;
                  this.errorMessage = "Vui lòng chọn mức theo dõi";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          },
        },
        monitorReasonInput: {
          options: {
            placeholder: "Nhập lý do theo dõi (bắt buộc khi mức > Bình thường)",
            label: 'Lý do theo dõi'
          },
          data: {
            name: "monitorReason",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let level = parseInt(that.dataDeviceMonitor.monitorLevelSelect.data.model, 10);
                let value = (that.dataDeviceMonitor.monitorReasonInput.data.model || "").trim();
                if (level > 0 && !value) {
                  this.isValid = false;
                  this.errorMessage = "Vui lòng nhập lý do theo dõi";
                } else if (value.length > 500) {
                  this.isValid = false;
                  this.errorMessage = "Lý do theo dõi tối đa 500 ký tự";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          },
        },
      },

      stopContentSelect: {
        options: {
          filter: false,
          label: "Chọn loại dừng phát nội dung",
          selectAllText: "Chọn loại dừng phát nội dung"
        },
        data: {
          name: "stopContent",
          items: [
            { key: '0', value: "⏹️ Dừng tất cả các bản tin" },
            { key: '1', value: "⏭ Dừng phát bản tin hiện tại, phát tiếp bản tin tiếp theo nếu có" },
            { key: '2', value: "⏸ Tạm dừng nội dung đang phát" },
            { key: '3', value: "▶️ Phát tiếp nội dung dừng trước đó" },
          ],
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.stopContentSelect.data.model;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "Vui lòng chọn loại dừng phát nội dung";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        },
      },

      onOffWattageSelect: {
        options: {
          filter: false,
          label: "Chọn thao tác công suất",
          selectAllText: "Chọn thao tác công suất"
        },
        data: {
          name: "",
          items: [
            { key: "0", value: "Tắt công suất" },
            { key: "1", value: "Bật công suất" },
          ],
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.onOffWattageSelect.data.model;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "Vui lòng chọn loại thao tác công suất";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        },
      },

      mainTable: {
        options: {
          fields: [],
          slots: ["checkbox", "index", "code", "volume", "version", "phoneNumber", "description", "activeStatus", "temperature",
            "connectStatus", "updateDate", "locationName", "action", "lastTimePing"],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: false,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          pageSize: 20,
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
          lazyLoad: this.$hasAuthor('ROLE_WARD') || this.$hasAuthor('ROLE_VILLAGE') ? true : false
        },
        dataSource: {
          url: "/devices/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            that.actionData.model.listDeviceSelectedId = [];
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    addTimeRange() {
      if (this.dataConfigTimeOnOffAC.timeRange.length == 0) {

        var startTime = this.$helper.plusDateTime(0, 'm').second(0).millisecond(0)._d;
        var endTime = this.$helper.plusDateTime(60, 'm').second(0).millisecond(0)._d;

        this.dataConfigTimeOnOffAC.timeRange.push(
        {
          start: startTime,
          end: endTime,
          isValid: false
        })

        
      } else {
        var rangeTimeSorted = this.sortRangeTime();
        var timeEnd = rangeTimeSorted[rangeTimeSorted.length - 1].end;
        var endTime = moment(timeEnd).add(10, 'm').second(0).millisecond(0).toDate();

        this.dataConfigTimeOnOffAC.timeRange.push({
          start: timeEnd,
          end: endTime,
          isValid: false
        })
      }

    },
    sortRangeTime(isClick) {
      var timeArr = this.dataConfigTimeOnOffAC.timeRange;
      var sortedTime = [];
      var tempTimesArr = [];
      timeArr.forEach(function (each, index) {
        tempTimesArr.push({ time: moment(each.start, "hh:mm:ss").unix(), index: index });
      });
      tempTimesArr.sort(function (a, b) {
        return a.time - b.time;
      });

      tempTimesArr.forEach(function (t) {
        sortedTime.push(timeArr[t.index])
      });
      if (isClick) {
        this.dataConfigTimeOnOffAC.timeRange = sortedTime;
      } else {
        return sortedTime;
      }
    },
    changeTimeRange(event, index) {
      this.dataConfigTimeOnOffAC.timeRange.splice(index, 1, event);
    },
    removeTimeRange(index) {
      this.dataConfigTimeOnOffAC.timeRange.splice(index, 1);
    },
    validateRangeTimeSorted() {
      // Kiểm tra nếu timeOff lớn hơn timeOn trong từng khoảng
      const validIntervals = this.dataConfigTimeOnOffAC.timeRange.every(item => item.end > item.start);

      if (!validIntervals) {
          return {
              isValid: false,
              message: "Thời gian bật phải nhỏ hơn thời gian tắt"
          };
      }

      const sortedList = this.sortRangeTime();

      // Kiểm tra các khoảng thời gian bị trùng
      for (let i = 0; i < sortedList.length - 1; i++) {
          const currentTimeOff = sortedList[i].end;
          const nextTimeOn = sortedList[i + 1].start;

          if (currentTimeOff > nextTimeOn) {
              return {
                  isValid: false,
                  message: "Thời gian cấu hình trùng nhau"
              };
          }
      }

      return { isValid: true, message: "" };
    },
    openPopupMap() {
      const targetPath = '/devices-management/map.html';
      this.$router.push({ path: targetPath }).catch(() => {
        // Fallback giữ hành vi cũ nếu điều hướng bị chặn/lỗi bất thường
        this.hereMapModal.isShow = true;
      });
    },
    clickStopContent(item, isStopAll) {
      this.isShowModalStopContent = true;
      this.actionData.model.isStopContentAll = isStopAll;
      this.actionData.model.deviceSelectedId = item;
    },
    submitDataStopContent() {
      let isValid = true;
      isValid &= this.stopContentSelect.data.validator.valid();
      if (!isValid) {
        return;
      }
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/stopContentPlaying",
        dataSubmit() {
          if (that.actionData.model.isStopContentAll) {
            return {
              id: '',
              ids: that.actionData.model.listDeviceSelectedId,
              type: that.stopContentSelect.data.model
            }
          } else {
            return {
              id: that.actionData.model.deviceSelectedId,
              ids: [],
              type: that.stopContentSelect.data.model
            }
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({ message: "Thực hiện dừng phát nội dung thành công" });
            that.isShowModalStopContent = false;
            that.stopContentSelect.data.model = '';
            that.loadDataMainTable();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitDataOnOffWattage() {
      let isValid = true;
      isValid &= this.onOffWattageSelect.data.validator.valid();
      if (!isValid) {
        return;
      }
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/onOffWattage",
        dataSubmit() {
          return {
            id: '',
            ids: that.actionData.model.listDeviceSelectedId,
            type: that.onOffWattageSelect.data.model
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({ message: `Thực hiện gửi lệnh ${that.onOffWattageSelect.data.model == 0 ? 'tắt' : 'bật'} công suất các thiết bị được chọn thành công` });
            that.onOffWattageSelect.data.model = '';
            that.isShowModalOnOffWattage = false;
            that.loadDataMainTable();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    updateStateEnableLog(value) {
      this.dataSubmitConfigAuthentication.enablePutLog = value;
    },
    previewFile: function () {
      this.modelShowSchedulePlaying.isShowModalPreview = true;
    },
    viewSchedulePlaying(item, type) {
      let that = this;
      if (type == 0) {      // xem lịch tbi truyền thanh
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/devices/findSchedulePlayingById",
          dataSubmit() {
            return {
              deviceId: item.id
            }
          },
          isJsonContentType: false,
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {
              that.modelShowSchedulePlaying.details = response.data.data;
              that.modelShowSchedulePlaying.selectedDevice = item.code;
              that.modelShowSchedulePlaying.isShow = true;
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      } else {    // nghe thử luồng streamer
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/devices/findChannelDigitalByDeviceId",
          dataSubmit() {
            return {
              deviceId: item.id
            }
          },
          isJsonContentType: false,
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {
              that.modelShowSchedulePlaying.details = {
                url: response.data.data,
                title: item.description,
              }
              that.modelShowSchedulePlaying.isShowModalPreview = true;
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      }
    },
    copyPhoneNumber(phoneNumber) {
      if (!phoneNumber) {
        return;
      }
      navigator.clipboard.writeText(phoneNumber);
      this.showSuccessMsg({ message: "Sao chép thành công" });
    },
    getInformationPhone(item) {
      let response = `<div class="text-left"><div><b>Nhà mạng:</b> ${item.networkProvider}</div>
                       <div><b>IMEI:</b> ${item.phoneImei}</div>`;
      // if (item.phoneDataCapacity != null) {
      //   response += `<div><b>Dung lượng:</b> ${item.phoneDataCapacity}</div>`;
      // }
      // if (item.phoneDateActive) {
      //   response += `<div><b>Data có hiệu lực:</b> ${this.$helper.formatDateDDMMYYYY(item.phoneDateActive)}</div>`;
      // }

      // if (item.phoneDateExpired) {
      //   response += `<div><b>Data hết hiệu lực:</b> ${this.$helper.formatDateDDMMYYYY(item.phoneDateExpired)}</div>`;
      // }
      // if (item.dateWarranty) {
      //   response += ` <div> <b>Thời hạn bảo hành:</b> ${this.$helper.formatDateDDMMYYYY(item.dateWarranty)} </div>`;
      // }
      if (item.phoneCcId) {
        response += ` <div> <b>ICCID:</b> ${item.phoneCcId} </div>`;
      }
      response += '</div>';
      return response;
    },
    generatePhoneNetWork(item) {
      var res = '';
      var phoneNetwork = item.phoneNetworkMode.toString();
      if (item && phoneNetwork) {
        // var network = phoneNetwork.split(".");
        switch (phoneNetwork) {
          case "0": {
            // res = 'NO SERVICE';
            res = '';
            break;
          }
          case "1": {
            res = 'GSM';
            break;
          }
          case "2": {
            res = 'G';
            break;
          }
          case "3": {
            res = 'E';
            break;
          }
          case "4": {
            res = '3G';
            break;
          }
          case "5": {
            res = '3G+';
            break;
          }
          case "6": {
            res = 'H';
            break;
          }
          case "7": {
            res = 'H+';
            break;
          }
          case "8": {
            res = 'LTE';
            break;
          }
          // case "9": {
          //   break;
          // }
          // case "10": {
          //   break;
          // }
          // case "11": {
          //   break;
          // }
          // case "12": {
          //   break;
          // }
          // case "13": {
          //   break;
          // }
          // case "14": {
          //   break;
          // }
          // case "15": {
          //   break;
          // }
          // case "16": {
          //   break;
          // }
          // case "23": {
          //   break;
          // }
          // case "24": {
          //   break;
          // }
        }
      }
      return res;
    },
    setupChangeDevice(item) {
      this.dataExchangeDevice.id = item.id;
      this.dataExchangeDevice.code = item.code;
      this.dataExchangeDevice.type = item.type;
      this.dataExchangeDevice.description = item.description;
      this.dataExchangeDevice.locationCode = item.locationCode;
      this.isShowModalExchangeDevice = true;
    },
    deviceExchangeSelected(item) {
      this.dataExchangeDevice.idExchange = item.id;
    },
    closeModalExchange(value) {
      this.isShowModalExchangeDevice = value;
    },
    submitExchangeDevice() {
      if (this.dataExchangeDevice.id == '' || this.dataExchangeDevice.idExchange == '') {
        return;
      }
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/exchangeDevice",
        dataSubmit: function () {
          return {
            id: that.dataExchangeDevice.id,
            idExchange: that.dataExchangeDevice.idExchange,
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({ message: "Thay đổi thiết bị thành công" });
            that.loadDataMainTable();
            that.isShowModalExchangeDevice = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setupAttachImage(item) {
      this.isShowModalAttachImage = true;
      this.dataAttachImage.id = item.id;
      this.dataAttachImage.images = [];
      this.dataAttachImage.oldImages = [];
      item.attachImages.map(each => {
        this.dataAttachImage.oldImages.push(each)
        this.dataAttachImage.images.push(each);
      })
      this.dataAttachImage.imagesRemove = [];
    },
    configBitrate(item) {
      this.dataConfigBitrate.id = item.id;
      this.dataConfigBitrate.bitrateSelect.data.model = item.bitrate;
      this.dataConfigBitrate.isShowModal = true;
    },
    configTimeOnOffAC(item) {
      this.dataConfigTimeOnOffAC.id = item.id;
      this.dataConfigTimeOnOffAC.errorMessage = "";
      this.dataConfigTimeOnOffAC.timeRange = [];
      if(item.timeOnOffACInfors) {
        for(var i = 0 ; i < item.timeOnOffACInfors.length; i++){
          var startTime = this.$helper.convertStringToDate(item.timeOnOffACInfors[i].timeOn, 'HH:mm');
          var endTime = this.$helper.convertStringToDate(item.timeOnOffACInfors[i].timeOff, 'HH:mm');

          this.dataConfigTimeOnOffAC.timeRange.push(
          {
            start: startTime,
            end: endTime,
            isValid: false
          })
        }
      } else {
        this.dataConfigTimeOnOffAC.timeRange = [];
      }
      this.dataConfigTimeOnOffAC.isShowModal = true;
    },
    submitConfigTimeOnOffAC() {
      if (!this.dataConfigTimeOnOffAC.timeRange || this.dataConfigTimeOnOffAC.timeRange.length == 0) {
        // this.dataConfigTimeOnOffAC.errorMessage = "Thời gian cấu hình không được để trống";
        // return;
      } else {
        var res = this.validateRangeTimeSorted();

        if(!res.isValid) {
          this.dataConfigTimeOnOffAC.errorMessage = res.message
          return;
        }
      }



      let that = this;

      var timeOnOffInfos = [];

      if(this.dataConfigTimeOnOffAC.timeRange) {
        for (let i = 0; i < this.dataConfigTimeOnOffAC.timeRange.length; i++) {
          var startTime = this.$helper.formatHHMM(this.dataConfigTimeOnOffAC.timeRange[i].start.getTime());
          var endTime = this.$helper.formatHHMM(this.dataConfigTimeOnOffAC.timeRange[i].end.getTime());
          timeOnOffInfos.push({
            timeOn: startTime,
            timeOff: endTime
          });
        }
      }
      
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/configTimeOnOffAC",
        dataSubmit: function () {
          return {
            id: that.dataConfigTimeOnOffAC.id,
            times: timeOnOffInfos,
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({ message: "Gửi lệnh cấu hình thời gian bật tắt nguồn ra thành công" });
            that.loadDataMainTable();
            that.dataConfigTimeOnOffAC.isShowModal = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitConfigBitrate() {
      if (!this.dataConfigBitrate.bitrateSelect.data.validator.valid()) {
        return;
      }
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/configBitrate",
        dataSubmit: function () {
          return {
            id: that.dataConfigBitrate.id,
            bitrate: that.dataConfigBitrate.bitrateSelect.data.model,
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({ message: "Gửi lệnh cấu hình bitrate thành công" });
            that.loadDataMainTable();
            that.dataConfigBitrate.isShowModal = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    removeAttachImage(image, index) {
      this.dataAttachImage.images.splice(index, 1);
      if (this.dataAttachImage.oldImages.includes(image)) {
        this.dataAttachImage.imagesRemove.push(image);
      }
    },
    async selectFile(event) {
      let that = this;
      if (event.target.files.length > 0) {
        // this.loading.value = true;
        if (this.dataAttachImage.images.length < 4) {
          Promise.all(
            (function* () {
              let _that = that;
              for (let file of event.target.files) {
                yield new Promise(resolve => {
                  let reader = new FileReader();
                  reader.onload = () => {
                    let data = {
                      file: file,
                      // urlBlob: _that.convertBlob(reader.result),
                      base64: reader.result,
                    }
                    resolve(data)
                  };
                  reader.readAsDataURL(file);
                })
              }
            })())
            .then(texts => {
              texts.map(each => {
                if (this.validateFile(each.file)) {
                  this.dataAttachImage.images.push(each.base64)
                }
              })
              // setTimeout(() => {
              // that.loading.value = false
              // }, 300)
            }).catch(error => {
              // that.loading.value = false;
            });
        }
      }
    },
    validateFile(file) {
      if (this.dataAttachImage.images.length >= 4) {
        return false;
      } else {
        if (file && file.type !== 'image/jpeg' && file.type !== 'image/png') {
          return false;
        }
        return true;
      }
    },
    showDetailImage(image) {
      this.showDetailUrl = image;
    },
    submitAttachImage() {
      let that = this;
      let isValid = that.validateAttachImage();
      if (!isValid) {
        return;
      }
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/attach_images",
        dataSubmit: function () {
          return {
            id: that.dataAttachImage.id,
            images: that.dataAttachImage.images,
            imagesRemove: that.dataAttachImage.imagesRemove,
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({ message: "Cập nhật ảnh đính kèm thành công" });
            that.loadDataMainTable();
            that.isShowModalAttachImage = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    validateAttachImage() {
      if (this.dataAttachImage.images.length == 0) {
        this.showErrorMsg({ message: "Cần tối thiểu 1 ảnh" });
        return false;
      }
      return true;
    },
    convertDataURIToBinary(dataURI) {
      let BASE64_MARKER = ';base64,';
      let base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      let base64 = dataURI.substring(base64Index);
      let raw = window.atob(base64);
      let rawLength = raw.length;
      let array = new Uint8Array(new ArrayBuffer(rawLength));
      for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array;
    },
    convertBlob(data) {
      let binary = this.convertDataURIToBinary(data);
      let blob = new Blob([binary], { type: 'image/png' });
      return URL.createObjectURL(blob);
    },
    loadDataMainTable: function (isUpdateFilter, isLoading) {
      this.$refs.mainTable.items.map(each => delete each._classes);
      this.$refs.mainTable.loadData(isUpdateFilter, isLoading);
    },
    changeSelectAll: function () {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listDeviceSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listDeviceSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listDeviceSelectedId = [];
      }
    },
    rowClickTable(value) {
      let targetClick = value.event.target;
      if (value.column === 'volume' && ($(targetClick).is("button") || $(targetClick).is("span") || $(targetClick).is("i"))) {
        return;
      }
      // Cột Thao tác: mọi click (toggler, menu, item) đều không chọn hàng
      if (value.column === 'action') {
        return;
      }
      // Click vào dropdown ở bất kỳ cột nào (menu đang mở) cũng không chọn hàng
      if ($(targetClick).closest('.dropdown-menu').length || $(targetClick).closest('.dropdown').length) {
        return;
      }
      if (value.column === 'activeStatus') {
        return;
      }
      if (value.column === 'phoneNumber') {
        return;
      }
      if (value && value.item && value.item.id) {
        if (this.actionData.model.listDeviceSelectedId.includes(value.item.id)) {
          const index = this.actionData.model.listDeviceSelectedId.indexOf(value.item.id)
          if (index > -1) { // only splice array when item is found
            this.actionData.model.listDeviceSelectedId.splice(index, 1); // 2nd parameter means remove one item only
            value.item._classes = 'inactive';
          }
        } else {
          value.item._classes = 'active';
          this.actionData.model.listDeviceSelectedId.push(value.item.id);
        }
      }
    },
    generateIconVolume(volume) {
      if (volume == 0) {
        return 'fa-volume-off'
      } else if (volume < 50) {
        return 'fa-volume-down'
      } else {
        return 'fa-volume-up'
      }
    },
    setupSelectOneAction: function (actionTypeKey, deviceId, deviceName, status, type) {
      let actionData = this.actionData.model;
      actionData.deviceSelectedId = deviceId;
      actionData.deviceSelectedName = deviceName;
      actionData.status = status | null;
      actionData.type = type | null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    canUseSpeakerTest(item) {
      if (!item || item.type !== 0) {
        return false;
      }
      return this.$hasAuthor('ROLE_ADMIN')
        || this.$hasAuthor('ROLE_PROVINCE')
        || this.$hasAuthor('ROLE_MANAGEMENT')
        || this.$hasAuthor('ROLE_MANAGEMENT_DEVICE');
    },
    startTraditionalSpeakerTest(item) {
      this.setupSelectOneAction('check_sound_speaker', item.id, item.code);
    },
    openDigitalSpeakerTestModal(item) {
      if (!this.$hasAuthor('ROLE_ADMIN')) {
        return;
      }
      this.dataTestSpeakerDigital.deviceId = item.id;
      this.dataTestSpeakerDigital.deviceCode = item.code;
      this.dataTestSpeakerDigital.durationSelect.data.model = '5';
      this.dataTestSpeakerDigital.channelDigitalSelect.data.model = '';
      this.dataTestSpeakerDigital.channelDigitalSelect.data.validator.isValid = true;
      this.dataTestSpeakerDigital.channelDigitalSelect.data.validator.errorMessage = '';
      this.dataTestSpeakerDigital.durationSelect.data.validator.isValid = true;
      this.dataTestSpeakerDigital.durationSelect.data.validator.errorMessage = '';
      this.dataTestSpeakerDigital.isShowModal = true;
      this.$nextTick(() => {
        if (this.$refs.testSpeakerChannelDigitalSelect) {
          this.$refs.testSpeakerChannelDigitalSelect.loadData();
        }
      });
    },
    buildDigitalSpeakerTestSchedulePayload() {
      const minutes = parseInt(this.dataTestSpeakerDigital.durationSelect.data.model, 10);
      const now = new Date();
      const endTime = this.$helper.plusDateTime(minutes, 'm').second(0).millisecond(0)._d;
      const today = this.$helper.formatDateDDMMYYYY(now.getTime());
      return {
        title: 'Thử loa',
        typeSource: '2',
        mode: '2',
        modeSchedule: '0',
        modeTime: '1',
        channelDigitalId: this.dataTestSpeakerDigital.channelDigitalSelect.data.model,
        scheduleBy: 1,
        devices: [this.dataTestSpeakerDigital.deviceId],
        fromDate: today,
        toDate: today,
        dates: [],
        startTimes: [],
        endTimes: [this.$helper.formatHHMMSS(endTime.getTime())],
        replays: [],
        times: [],
        priority: false,
        isConfirm: false,
        deviceIgnoreIds: [],
        selectedAll: false,
      };
    },
    submitDigitalSpeakerTest() {
      let that = this;
      let isValid = true;
      isValid &= that.dataTestSpeakerDigital.channelDigitalSelect.data.validator.valid();
      isValid &= that.dataTestSpeakerDigital.durationSelect.data.validator.valid();
      if (!isValid) {
        return;
      }
      that.$helper.loadDataSource({
        loading: that.loading,
        url: '/schedule/add',
        dataSubmit: function () {
          return that.buildDigitalSpeakerTestSchedulePayload();
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            if (response.data.data && response.data.data.id) {
              that.showErrorMsg({
                message: response.data.data.msg || 'Không thể tạo lịch thử loa. Thiết bị có thể đang phát lịch khác.'
              });
            } else {
              that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            }
          } else {
            that.showSuccessMsg({
              message: 'Đã tạo lịch thử loa link số hóa cho thiết bị ' + that.dataTestSpeakerDigital.deviceCode + ' thành công'
            });
            that.dataTestSpeakerDigital.isShowModal = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    openGoogleMapDirections(item) {
      const lat = item.latitude != null && item.latitude !== '' ? Number(item.latitude) : NaN;
      const lng = item.longitude != null && item.longitude !== '' ? Number(item.longitude) : NaN;
      if (isNaN(lat) || isNaN(lng)) {
        this.showErrorMsg({ message: 'Thiết bị chưa có tọa độ (vĩ độ/kinh độ). Vui lòng cấu hình trong Cấu hình thiết bị.' });
        return;
      }
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    setupConfigInformation(item) {
      let that = this;
      // this.dataSetInformationDevice.locationLevelSelect.data.model = null;
      this.dataSetInformationDevice.locationLevelSelect.data.items = item.type == 0 ? [
        { key: "0", value: "Cấp Tỉnh" },
        { key: "1", value: "Cấp Huyện" },
        { key: "2", value: "Cấp Xã" },
        { key: "3", value: "Cấp Thôn" },
      ] : [
        { key: "1", value: "Cấp Huyện" },
        { key: "2", value: "Cấp Xã" },
        { key: "3", value: "Cấp Thôn" },
      ]
      this.dataSetInformationDevice.id = item.id;
      this.dataSetInformationDevice.type = item.type;
      this.dataSetInformationDevice.locationCode = item.locationCode;
      this.dataSetInformationDevice.supplierId = item.supplierId;
      this.dataSetInformationDevice.longitudeInput.data.model = item.longitude;
      this.dataSetInformationDevice.latitudeInput.data.model = item.latitude;
      this.dataSetInformationDevice.locationCodeSelect.data.validator.isValid = true;
      this.dataSetInformationDevice.descriptionInput.data.model = item.description;
      this.dataSetInformationDevice.speakerConf.data.model = item.speakerConf;
      setTimeout(() => {
        if (item.type == 0) {
          that.dataSetInformationDevice.locationLevelSelect.data.model = item.locationLevel | 0;
        } else {
          that.dataSetInformationDevice.locationLevelSelect.data.model = item.locationLevel | 1;
        }

        that.dataSetInformationDevice.supplierSelect.data.model = item.supplierId;
      })
    },
    setupConfigAuthentication(item) {
      this.dataSubmitConfigAuthentication.id = item.id;
      this.dataSubmitConfigAuthentication.enablePutLog = item.enableLog;
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/constant/getListKeyAuthenticationDevice",
        dataSubmit() {
          return {}
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.dataConfigAuthentication = response.data.data.response;
            that.dataConfigAuthentication.enablePutLog = item.enableLog;
            that.dataSubmitConfigAuthentication.authenServerSelect.data.items = response.data.data.response.authensServer;
            that.isShowModalConfigAuthentication = true;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitConfigAuthentication() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/devices/configAuthentication",
        dataSubmit() {
          return {
            id: that.dataSubmitConfigAuthentication.id,
            enableLog: that.dataSubmitConfigAuthentication.enablePutLog,
            authenCode: that.dataSubmitConfigAuthentication.authenServerSelect.data.model,
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({ message: "Xác nhận gửi cấu hình xác thực tới thiết bị thành công" });
            that.isShowModalConfigAuthentication = false;
            that.loadDataMainTable();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setupUpdateFW(item) {
      let that = this;
      if (item) {
        that.dataUpdateFW.id = item.id;
      }
      that.$helper.loadDataSource({
        url: "/version-fw/loadAllForSelected",
        dataSubmit: function () {
          return {};
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.dataUpdateFW.versionSelect.data.items = response.data.data;
            that.dataUpdateFW.isShowModalUpdateFW = true;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    submitUpdateFW() {
      let that = this;
      // if (!that.dataUpdateFW.versionSelect.data.validator.valid()) {
      //   return;
      // }
      that.$helper.loadDataSource({
        url: "/devices/update-app",
        dataSubmit: function () {
          return {
            id: that.dataUpdateFW.id || 0,
            versionId: that.dataUpdateFW.versionSelect.data.model,
            ids: that.actionData.model.listDeviceSelectedId
          };
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({ message: "Gửi lệnh thực hiện cập nhật phần mềm thành công" })
            that.dataUpdateFW.isShowModalUpdateFW = false;
          } else {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    setupATCommand(item) {
      this.isShowModalATCommand = true;
      this.showATCmdModel.code = item.code;
      this.showATCmdModel.phoneNumber = item.phoneNumber;
      this.showATCmdModel.deviceId = item.id;
    },
    checkBoxSpeakerConf(value, index) {
      this.dataSetInformationDevice.speakerConf.data.model[index] = value;
    },
    submitConfigInformation() {
      let isValid = true;
      isValid &= this.dataSetInformationDevice.locationCodeSelect.data.validator.valid();
      isValid &= this.dataSetInformationDevice.speakerConf.data.validator.valid();
      if (!isValid) {
        return;
      }
      let that = this;
      if (that.$hasAuthor("ROLE_ADMIN") || that.$hasAuthor("ROLE_MANAGEMENT")) {
        this.$helper.loadDataSource({
          url: "/devices/configInformation",
          dataSubmit: function () {
            return {
              id: that.dataSetInformationDevice.id,
              locationCode: that.dataSetInformationDevice.locationCodeSelect.data.model,
              longitude: that.dataSetInformationDevice.longitudeInput.data.model,
              latitude: that.dataSetInformationDevice.latitudeInput.data.model,
              description: that.dataSetInformationDevice.descriptionInput.data.model,
              speakerConf: that.dataSetInformationDevice.speakerConf.data.model,
              supplierId: that.dataSetInformationDevice.supplierSelect.data.model
            };
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
              that.$helper.setupErrorModel(response.data.data, that.$data.dataSetInformationDevice);
            } else {
              that.showSuccessMsg({ message: "Cập nhật thông tin thiết bị thành công" });
              that.isShowModalConfigInformation = false;
              that.loadDataMainTable(false, true);
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      } else {
        this.$helper.loadDataSource({
          url: "/devices/user-configInformation",
          dataSubmit: function () {
            return {
              id: that.dataSetInformationDevice.id,
              description: that.dataSetInformationDevice.descriptionInput.data.model
            };
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
              that.$helper.setupErrorModel(response.data.data, that.$data.dataSetInformationDevice);
            } else {
              that.showSuccessMsg({ message: "Cập nhật thông tin thiết bị thành công" });
              that.isShowModalConfigInformation = false;
              that.loadDataMainTable(false, true);
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      }
    },
    changeVolume(id, _volume, isChangeAll) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/updateVolume",
        isJsonContentType: false,
        dataSubmit: function () {
          let dataReq = null;
          if (isChangeAll) {
            dataReq = {
              deviceId: '',
              volume: _volume,
              deviceIds: that.actionData.model.listDeviceSelectedId
            }
          } else {
            dataReq = {
              deviceId: id || '',
              volume: _volume,
              deviceIds: []
            }
          }
          return dataReq;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.isShowModalChangeVolumeMultipleDevice = false;
            that.showSuccessMsg({
              message: "Thực hiện thao tác thay đổi âm lượng thành công"
            });
            that.loading.value = false;
            if (isChangeAll) {
              that.loadDataMainTable(false, false);
              that.volumeChangeMultipleDevice = 0;
              //   that.actionData.model.listDeviceSelectedId = [];
            }
            $('body').click();
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    restartDevice(id) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/restart",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: id
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thực hiện thao tác khởi động lại thiết bị thành công"
            });
            that.loadDataMainTable(false, false);
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    getLogDevice(id) {
      let that = this;
      that.$store.commit('setLogDevice', true)
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/getLog",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: id
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thực hiện thao tác lấy log thiết bị thành công"
            });
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setupAddPhoneNumber(item) {
      this.dataAddPhoneNumber.id = item.id;
      this.dataAddPhoneNumber.phoneNumberInput.data.model = item.phoneNumber;
      this.dataAddPhoneNumber.isShowModal = true;
    },
    submitAddPhoneNumber() {
      let that = this;
      let isValid = true;
      isValid &= this.dataAddPhoneNumber.phoneNumberInput.data.validator.valid();
      if (!isValid) {
        return;
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/addPhoneNumber",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: that.dataAddPhoneNumber.id,
            phoneNumber: that.dataAddPhoneNumber.phoneNumberInput.data.model,
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({ message: "Thêm SĐT thành công" });
            that.dataAddPhoneNumber.isShowModal = false;
            that.loadDataMainTable();
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    openMonitorView(item) {
      this.monitorView.code = item.code;
      this.monitorView.monitorLevel = item.monitorLevel;
      this.monitorView.monitorReason = item.monitorReason;
      this.monitorView.monitorAt = item.monitorAt;
      this.monitorView.monitorBy = item.monitorBy;
      this.monitorView.isShow = true;
    },
    setupMonitorConfig(item) {
      this.dataDeviceMonitor.id = item.id;
      this.dataDeviceMonitor.code = item.code;
      this.dataDeviceMonitor.monitorAt = item.monitorAt;
      this.dataDeviceMonitor.monitorBy = item.monitorBy;
      this.dataDeviceMonitor.monitorLevelSelect.data.model = item.monitorLevel != null ? String(item.monitorLevel) : "0";
      this.dataDeviceMonitor.monitorReasonInput.data.model = item.monitorReason || "";
      this.dataDeviceMonitor.monitorLevelSelect.data.validator.isValid = true;
      this.dataDeviceMonitor.monitorReasonInput.data.validator.isValid = true;
      this.dataDeviceMonitor.isShowModal = true;
    },
    submitMonitorConfig() {
      let that = this;
      let isValid = true;
      isValid &= this.dataDeviceMonitor.monitorLevelSelect.data.validator.valid();
      isValid &= this.dataDeviceMonitor.monitorReasonInput.data.validator.valid();
      if (!isValid) {
        return;
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/updateMonitorConfig",
        dataSubmit: function () {
          return {
            id: that.dataDeviceMonitor.id,
            monitorLevel: parseInt(that.dataDeviceMonitor.monitorLevelSelect.data.model, 10),
            monitorReason: (that.dataDeviceMonitor.monitorReasonInput.data.model || "").trim(),
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({ message: "Cập nhật cấu hình theo dõi thành công" });
            that.dataDeviceMonitor.isShowModal = false;
            that.loadDataMainTable(false, false);
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setupImport() {
      this.dataImport.isShowModal = true;
    },
    selectFileNCC() {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file;
      if (file && file.files[0]) {
          file = file.files[0];
          this.dataImport.selectedFiles.data.loading = true;
          reader.readAsDataURL(file);

          reader.onload = function () {
              that.dataImport.selectedFiles.options.fileName = file.name;
              that.validateFileNCC(file.type, file.size);
              that.dataImport.selectedFiles.data.model.size = file.size;
              that.dataImport.selectedFiles.data.model.fileName = file.name;
              that.dataImport.selectedFiles.data.model.type = file.type;
          }
          reader.onloadend = function () {
              that.dataImport.selectedFiles.data.loading = false;
          }
      } else {
          that.dataImport.selectedFiles.options.fileName = "Chọn tệp";
          that.dataImport.selectedFiles.data.model.size = "";
          that.dataImport.selectedFiles.data.model.fileName = "";
          that.dataImport.selectedFiles.data.model.type = "";
          that.validateFileNCC();
      }
    },
    validateFileNCC(type, size) {
        let isValid = true;
        if ((type && type != undefined) && (size && size != undefined)) {
            isValid = this.validateFileTypeNCC(type, size);
        } else {
            if (this.dataImport.selectedFiles.data.model.type && this.dataImport.selectedFiles.data.model.size) {
                isValid = this.validateFileTypeNCC(this.dataImport.selectedFiles.data.model.type, this.dataImport.selectedFiles.data.model.size);
            } else {
                if (this.dataImport.selectedFiles.data.model.fileName === '') {
                    this.dataImport.selectedFiles.data.validator.isValid = false;
                    this.dataImport.selectedFiles.data.validator.errorMessage = "Tệp tin không được để trống";
                    isValid = false;
                }
            }
        }
        return isValid;
    },
    validateFileTypeNCC(type, size) {
        let isValid = true;
        if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type === "application/vnd.ms-excel") {
            this.dataImport.selectedFiles.data.validator.isValid = true;
            this.dataImport.selectedFiles.data.validator.errorMessage = "";
        } else {
            this.dataImport.selectedFiles.data.validator.isValid = false;
            this.dataImport.selectedFiles.data.validator.errorMessage = "Sai định dạng tệp tin";
            isValid = false;
        }
        return isValid;
    },
    submitImport() {
      let that = this;
      let isValid = true;
      isValid &= this.dataImport.selectedFiles.data.validator.valid();
      isValid &= this.dataImport.supplierSelect.data.validator.valid();
      if (!isValid) {
        return;
      }
      that.loading.value = true;
      let formData = new FormData();
      formData.append("file", that.$refs.file.files[0]);
      formData.append("supplierId", that.dataImport.supplierSelect.data.model)

      that.$helper.loadDataSource({
          url: "/supplier/import-device-supplier",
          dataSubmit: function () {
              return formData;
          },
          isMultiPartFormData: true,
          successCallback: function (response) {
              if (!that.$helper.validResponse(that.$router, response.data)) {
                  that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
                  that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
              } else {
                  that.showSuccessMsg({ message: "Import NCC thành công" });
              }
              that.dataImport.isShowModal = false;

              that.loading.value = false;
              that.dataImport.selectedFiles.options.fileName = "Chọn tệp";
              that.dataImport.selectedFiles.data.model.size = "";
              that.dataImport.selectedFiles.data.model.fileName = "";
              that.dataImport.selectedFiles.data.model.type = "";
              that.loadDataMainTable();
          },
          errorCallback: function (error) {
              that.$helper.handleError(that.$router, error);
              that.loading.value = false
          }
      });
    },

    scheduleSyncActionMenuPortal() {
      if (this._actionMenuPortalTimer != null) {
        clearTimeout(this._actionMenuPortalTimer);
      }
      this._actionMenuPortalTimer = setTimeout(() => {
        this._actionMenuPortalTimer = null;
        this.syncActionMenuPortal();
      }, 0);
    },

    finishActionMenuPortalPosition(menu, dropdownRootEl) {
      if (!dropdownRootEl || !menu) return;
      const vm = dropdownRootEl.__vue__;
      const popperUpdate = () => {
        if (vm && vm._popper && typeof vm._popper.update === "function") {
          vm._popper.update();
        } else {
          window.dispatchEvent(new Event("resize"));
        }
      };
      popperUpdate();
      if (!menu.classList.contains("action-table-dropdown-menu--positioning")) {
        return;
      }
      requestAnimationFrame(() => {
        popperUpdate();
        requestAnimationFrame(() => {
          popperUpdate();
          menu.classList.remove("action-table-dropdown-menu--positioning");
        });
      });
    },

    syncActionMenuPortal() {
      if (typeof document === "undefined") return;
      const bodyMenus = "body > .dropdown-menu.action-table-dropdown-menu";
      if (!this.isMobileViewport) {
        document.querySelectorAll(bodyMenus).forEach((menu) => {
          menu.classList.remove("action-table-dropdown-menu--positioning");
          if (menu._deviceListPortalParent && menu._deviceListPortalParent.appendChild) {
            menu._deviceListPortalParent.appendChild(menu);
          }
          menu._deviceListPortalParent = null;
        });
        return;
      }
      if (!this.$el) return;
      this.$el.querySelectorAll(".action-btn-group .action-table-dropdown-menu.show").forEach((menu) => {
        if (menu.parentElement !== document.body) {
          menu.classList.add("action-table-dropdown-menu--positioning");
          const dropdownRoot = menu.parentElement;
          menu._deviceListPortalParent = dropdownRoot;
          document.body.appendChild(menu);
          this.finishActionMenuPortalPosition(menu, dropdownRoot);
        }
      });
      document.querySelectorAll(bodyMenus).forEach((menu) => {
        if (!menu.classList.contains("show") && menu._deviceListPortalParent) {
          menu.classList.remove("action-table-dropdown-menu--positioning");
          menu._deviceListPortalParent.appendChild(menu);
          menu._deviceListPortalParent = null;
        }
      });
    },

    initActionMenuPortalObserver() {
      this.teardownActionMenuPortal();
      if (!this.$el) return;
      this._actionMenuPortalObserver = new MutationObserver(() => {
        this.scheduleSyncActionMenuPortal();
      });
      this._actionMenuPortalObserver.observe(this.$el, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
        childList: true
      });
      this.$nextTick(() => this.syncActionMenuPortal());
    },

    teardownActionMenuPortal() {
      if (this._actionMenuPortalTimer != null) {
        clearTimeout(this._actionMenuPortalTimer);
        this._actionMenuPortalTimer = null;
      }
      if (this._actionMenuPortalObserver) {
        this._actionMenuPortalObserver.disconnect();
        this._actionMenuPortalObserver = null;
      }
      if (typeof document === "undefined") return;
      document.querySelectorAll("body > .dropdown-menu.action-table-dropdown-menu").forEach((menu) => {
        menu.classList.remove("action-table-dropdown-menu--positioning");
        if (menu._deviceListPortalParent && menu._deviceListPortalParent.appendChild) {
          menu._deviceListPortalParent.appendChild(menu);
        }
        menu._deviceListPortalParent = null;
      });
    }
  },
  created: function () {
  },
  mounted() {
    this._actionDropdownMql = window.matchMedia("(max-width: 767.98px)");
    this._syncActionDropdownViewport = () => {
      this.isMobileViewport = this._actionDropdownMql.matches;
      this.$nextTick(() => this.syncActionMenuPortal());
    };
    this._syncActionDropdownViewport();
    if (this._actionDropdownMql.addEventListener) {
      this._actionDropdownMql.addEventListener("change", this._syncActionDropdownViewport);
    } else {
      this._actionDropdownMql.addListener(this._syncActionDropdownViewport);
    }

    if (this.$hasAuthor("ROLE_ADMIN")) {
      this.$refs.dataSetSupplierSelect.loadData();
      this.mainTable.options.fields = [
        { key: "checkbox", label: "#", sorter: false, filter: false },
        { key: "updateDate", label: "Cập nhật cuối", _style: "width:10%" },
        { key: "code", label: "Mã thiết bị" },
        { key: "phoneNumber", label: "Số thuê bao/IP", _style: "width:12%;" },
        { key: "activeStatus", label: "Trạng thái hoạt động" },
        { key: "connectStatus", label: "Trạng thái kết nối" },
        { key: "volume", label: "Âm lượng", _style: "width:8%;" },
        { key: "description", label: "Mô tả địa chỉ", _style: "min-width:15%" },
        { key: "locationName", label: "Địa bàn" },
        { key: "version", label: "Version" },
        { key: "supplier", label: "NCC" },
        { key: "action", label: "Thao tác", sorter: false, filter: false },
      ];
    } else if (this.$hasAuthor("ROLE_MANAGEMENT_DEVICE")) {
      this.$refs.dataSetSupplierSelect.loadData();
      this.mainTable.options.fields = [
        { key: "checkbox", label: "#", sorter: false, filter: false },
        { key: "updateDate", label: "Cập nhật cuối", _style: "width:10%" },
        { key: "code", label: "Mã thiết bị" },
        { key: "phoneNumber", label: "Số thuê bao/IP", _style: "width:12%;" },
        { key: "activeStatus", label: "Trạng thái hoạt động" },
        { key: "connectStatus", label: "Trạng thái kết nối" },
        { key: "volume", label: "Âm lượng", _style: "width:8%;" },
        { key: "description", label: "Mô tả địa chỉ", _style: "min-width:15%" },
        { key: "locationName", label: "Địa bàn" },
        { key: "version", label: "Version" },
        { key: "supplier", label: "NCC" },
        { key: "action", label: "Thao tác", sorter: false, filter: false },
      ];
    } else {
      if((STYLE_SHOW_DEVICE && STYLE_SHOW_DEVICE == 'tna') && this.$hasAuthor("ROLE_MANAGEMENT")) {
        this.mainTable.options.fields = [
          { key: "checkbox", label: "#", sorter: false, filter: false },
          { key: "description", label: "Tên thiết bị", _style: "min-width:5%" },
          { key: "connectStatus", label: "Trạng thái kết nối" },
          { key: "volume", label: "Âm lượng", _style: "width:8%;" },
          { key: "activeStatus", label: "Trạng thái hoạt động" },
          { key: "code", label: "Mã thiết bị" },
          { key: "phoneNumber", label: "Số thuê bao/IP", _style: "width:12%;" },
          { key: "locationName", label: "Địa bàn" },
          { key: "updateDate", label: "Cập nhật cuối", _style: "width:10%" },
          { key: "version", label: "Version" },
          { key: "action", label: "Thao tác", sorter: false, filter: false },
        ]
      } else if(this.$hasAuthor("ROLE_MANAGEMENT")) {
          this.$refs.dataSetSupplierSelect.loadData();
          this.mainTable.options.fields = [
          { key: "checkbox", label: "#", sorter: false, filter: false },
          { key: "updateDate", label: "Cập nhật cuối", _style: "width:10%" },
          // { key: "lastTimePing", label: "Kết nối cuối", _style: "width:10%" },
          { key: "code", label: "Mã thiết bị" },
          { key: "phoneNumber", label: "Số thuê bao/IP", _style: "width:12%;" },
          { key: "activeStatus", label: "Trạng thái hoạt động" },
          { key: "connectStatus", label: "Trạng thái kết nối" },
          { key: "volume", label: "Âm lượng", _style: "width:8%;" },
          { key: "description", label: "Mô tả địa chỉ", _style: "min-width:15%" },
          { key: "locationName", label: "Địa bàn" },
          { key: "version", label: "Version" },
          { key: "supplier", label: "NCC" },
          { key: "action", label: "Thao tác", sorter: false, filter: false },
        ]
      } else {
        this.mainTable.options.fields = [
          { key: "checkbox", label: "#", sorter: false, filter: false },
          { key: "updateDate", label: "Cập nhật cuối", _style: "width:10%" },
          { key: "code", label: "Mã thiết bị" },
          { key: "phoneNumber", label: "Số thuê bao/IP", _style: "width:12%;" },
          { key: "activeStatus", label: "Trạng thái hoạt động" },
          { key: "connectStatus", label: "Trạng thái kết nối" },
          { key: "volume", label: "Âm lượng", _style: "width:8%;" },
          { key: "description", label: "Mô tả địa chỉ", _style: "min-width:15%" },
          { key: "locationName", label: "Địa bàn" },
          { key: "action", label: "Thao tác", sorter: false, filter: false },
        ]
      }
    }

    this.$nextTick(() => this.initActionMenuPortalObserver());
  },
  beforeDestroy() {
    this.teardownActionMenuPortal();
    if (this._actionDropdownMql && this._syncActionDropdownViewport) {
      if (this._actionDropdownMql.removeEventListener) {
        this._actionDropdownMql.removeEventListener("change", this._syncActionDropdownViewport);
      } else {
        this._actionDropdownMql.removeListener(this._syncActionDropdownViewport);
      }
    }
  },
  watch: {
    "actionData.model.listDeviceSelectedId": function (newValue) {
      let that = this;
      if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
        that.$refs.mainTable.items.map(each => each._classes = 'active');
      } else {
        that.actionData.model.selectedAll = false;
        if (newValue.length == 0) {
          that.$refs.mainTable.items.map(each => each._classes = 'inactive');
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
        // this.wardCodeInput.options.disabled = false;
      } else {
        // this.wardCodeInput.data.items = [];
        // this.wardCodeInput.options.disabled = true;
      }
      this.$refs.wardCodeInput.loadData();
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
    'dataSetInformationDevice.locationLevelSelect.data.model': function (value, old) {
      if (value) {
        this.$refs.dataSetLocationLocationCodeSelect.loadData();
      }
    },
    'isShowModalExchangeDevice': function (value) {
      if (!value) {
        this.dataExchangeDevice = {
          id: '',
          code: '',
          idExchange: ''
        }
      }
    }
  },
  computed: {
    actionDropdownPlacement() {
      return this.isMobileViewport ? "top-end" : "bottom-end";
    },
    actionDropdownPopperOptions() {
      const mobile = this.isMobileViewport;
      return {
        strategy: "fixed",
        placement: mobile ? "top-end" : "bottom-end",
        modifiers: [
          { name: "offset", options: { offset: mobile ? [-40, 8] : [-40, 0] } },
          { name: "flip", enabled: true },
          {
            name: "preventOverflow",
            options: {
              padding: 10,
              altBoundary: true,
              rootBoundary: "viewport"
            }
          }
        ]
      };
    }
  }
};
</script>
<style>
.progress-xs {
  height: 7px !important;
}


.btn-time-ranger:hover~.btn-remove-time {
  display: inline-block !important;
}

.btn-remove-time {
  width: 18px;
  cursor: pointer;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 0;
  padding: 2px;
  border-radius: 50%;
  background: red;
  color: white;
}
</style>

<style scoped>
.speaker {
  font-size: 20px;
}

.previewFile {
  font-weight: 600;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.blink {
  animation: blink 1.3s infinite;
  border: 1px solid;
  border-radius: 15px;
  padding: 2px 10px;
  background: rgba(0, 128, 0, 0.56);
  color: white;
  font-weight: 600;
  font-size: 12px;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>
<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';

#deviceList {

  .description-device {
    display: inline-block;
    min-width: 150px;
    max-width: 200px;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    line-height: 1.4;
    vertical-align: top;
  }

  .lightbox {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    padding-top: 30px;
    text-align: center;

    img {
      height: 95vh;
    }
  }

  .slider.override {
    width: 200px !important;
    ;
    max-width: 200px !important;
    ;
    //padding: 0 !important;
  }

  .range-slider-rail,
  .range-slider-fill {
    height: 6px !important;
  }

  .range-slider-fill {
    background-color: #0b98ff !important;
  }

  .range-slider-knob {
    width: 15px !important;
    height: 15px !important;
  }

  .range-slider {
    padding: unset !important;
  }

  .dropdown-volume {
    padding: unset;
    border-radius: 50px;
  }

  .dropdown-volume a:hover {
    background: none !important;
  }

  .custom-toggle-volume {
    min-width: 70px;
    display: inline-flex !important;
    justify-content: center;
  }

  .custom-toggle-volume i {
    margin-top:0px !important;
  }

  .volume .dropdown {
    display: inline-flex !important;
  }

  .action-custom {
    min-height: 2rem;
    overflow: visible;
  }

  .group-btn-action {
    height: 35px;
    justify-content: center;
  }

  .group-btn-action:hover {
    background: unset !important;
  }

  .action-btn-group {
    width: 1%;
    white-space: nowrap;
    padding-right: 0.5rem !important;
  }

  .action-btn-group .dropdown {
    display: inline-block;
  }

  .action-btn-group .btn {
    padding: 0.35rem 0.6rem!important;
    min-width: auto;
  }

  .action-dropdown-toggler {
    display: inline-flex;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 500;
    white-space: nowrap;
  }

  .action-table-dropdown-menu {
    width: fit-content;
    max-width: min(90vw, 252px);
    min-width: 0;
    max-height: 320px!important;
    overflow-y: auto;
    padding: 0.35rem 0;
    border-radius: 10px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
    border: 1px solid #e5e7eb;
    margin-top:0px!important;
    box-sizing: border-box;
  }

  /* Grid: icon cột 1, chữ (+ text node) cột 2 — tránh tràn một dòng như flex */
  .action-dropdown-item {
    display: grid;
    grid-template-columns: min-content 1fr;
    column-gap: 10px;
    align-items: start;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    cursor: pointer;
    transition: background 0.15s;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
    min-width: 0;
    max-width: 100%;
    line-height: 1.4;
    box-sizing: border-box;
  }

  .action-dropdown-item > i,
  .action-dropdown-item > svg,
  .action-dropdown-item > .c-icon {
    justify-self: start;
    margin-top: 0.12em;
  }

  .action-dropdown-item:hover {
    background: #f3f4f6;
  }

  .action-dropdown-item--danger {
    color: #dc2626;
  }

  .action-dropdown-item--danger:hover {
    background: #fef2f2;
  }

  .device-code-cell {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 4px;
    min-width: 0;
  }

  .device-code-line {
    display: inline-flex;
    align-items: center;
    column-gap: 6px;
    max-width: 100%;
    line-height: 1.15;
  }

  .device-code-value {
    display: inline-block;
    max-width: 120px;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .device-code-copy-btn {
    flex-shrink: 0;
    font-size: 17px;
    font-weight: 600;
    cursor: pointer;
    line-height: 1;
  }

  .device-code-test-speaker-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 28px;
    height: 24px;
    padding: 0 6px;
    line-height: 1;
    flex-shrink: 0;
  }

  .device-code-test-speaker-btn .fa {
    font-size: 13px;
  }

  .device-code-test-speaker-menu {
    min-width: 220px;
  }

  .device-code-type {
    display: inline-flex;
    align-items: center;
    line-height: 1.1;
    white-space: nowrap;
    margin: 0;
  }

  .device-code-monitor {
    display: inline-flex;
    align-items: center;
    line-height: 1.1;
    white-space: nowrap;
    margin: 0;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .device-code-monitor--clickable {
    cursor: pointer;
  }

  .monitor-view-reason {
    white-space: pre-wrap;
    word-break: break-word;
  }

  .attachImage {
    position: relative;
    width: 100%;
    border-radius: 15px;
    cursor: pointer;
    height: 500px;
    object-fit: cover;

    &:hover {
      opacity: 1;
    }
  }

  .editAttachImage {
    cursor: pointer;
    position: absolute;
    border: 1px solid rgba(128, 128, 128, 0.52);
    color: #c51a1a;
    font-size: 18px;
    background: white;
    top: -10px;
    right: 0px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    border-radius: 100%;

    &:hover {
      background: red;
      color: white;
    }
  }

  $input-file-color: grey;
  $input-file-hover-color: black;

  input[type=file] {
    outline: 0;
    opacity: 0;
    pointer-events: none;
    user-select: none;
  }

  .label {
    width: 120px;
    //height: 100%;
    border: 2px dashed $input-file-color;
    border-radius: 5px;
    display: block;
    padding: 1.2em;
    transition: border 300ms ease;
    cursor: pointer;
    text-align: center;

    i {
      display: block;
      font-size: 42px;
      padding-bottom: 16px;
    }

    i,
    .title {
      color: $input-file-color;
      transition: 200ms color;
    }

    &:hover {
      border: 2px solid $input-file-hover-color;

      i,
      .title {
        color: $input-file-hover-color;
      }
    }
  }


  #bars {
    position: relative;
    width: 32px;
    height: 20px;
    display: inline-flex;

    .bar {
      position: absolute;
      bottom: 0;
      width: 4px;

      &:nth-child(1) {
        height: 6px;
        left: 0px;
      }

      &:nth-child(2) {
        height: 10px;
        left: 7px;
      }

      &:nth-child(3) {
        height: 14px;
        left: 14px;
      }

      &:nth-child(4) {
        height: 18px;
        left: 21px;
      }
    }
  }

  /* Mobile: menu thao tác được append ra body (JS) — giữ scroll ngang .table-responsive, z-index khi mở */
  @media (max-width: 767.98px) {
    .action-btn-group .dropdown.show {
      z-index: 2040;
    }

    .action-table-dropdown-menu.dropdown-menu.show {
      z-index: 2050 !important;
    }

    .dropup .action-table-dropdown-menu.dropdown-menu {
      margin-top: 0 !important;
      margin-bottom: 6px !important;
    }
  }
}
</style>
<style>
.tooltip.device-code-speaker-tooltip .tooltip-inner {
  white-space: nowrap !important;
  width: auto !important;
  max-width: none !important;
}
</style>
